(function () {
  'use strict';
  if (window.Store) return;

  var state = {
    user: null,
    token: null,
    cart: null,
    cartCount: 0,
    sessionId: null,
    lang: 'en',
    occasionProfile: null,
    cartId: null,
    theme: 'dark',
    recentlyViewed: [],
    hasSeenExitIntent: false,
    rateLimitBackoffEnd: 0
  };

  var listeners = {};
  var _socket = null;
  var _bc = null;

  function on(event, cb) {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(cb);
    return function () {
      listeners[event] = listeners[event].filter(function (f) { return f !== cb; });
    };
  }

  function emit(event, data) {
    (listeners[event] || []).forEach(function (cb) {
      try { cb(data); } catch (e) { console.warn('[Store] listener error:', e); }
    });
  }

  function set(key, value) {
    state[key] = value;
    emit(key, value);
    emit('change', state);
    if (key === 'token') {
      if (value) {
        localStorage.setItem('bloom_token', value);
        _joinUserRoom();
      } else {
        localStorage.removeItem('bloom_token');
      }
      _broadcast({ type: 'token', value: value });
    }
    if (key === 'user') {
      if (value) {
        try { localStorage.setItem('bloom_user', JSON.stringify(value)); } catch {}
      } else {
        localStorage.removeItem('bloom_user');
      }
      _broadcast({ type: 'user', value: value });
    }
    if (key === 'cartCount') {
      _broadcast({ type: 'cartCount', value: value });
    }
    if (key === 'theme') {
      try { localStorage.setItem('bloom_theme', value); } catch {}
      _applyTheme(value);
      _broadcast({ type: 'theme', value: value });
    }
    if (key === 'cartId' || key === 'sessionId' || key === 'lang' || key === 'occasionProfile' || key === 'hasSeenExitIntent') {
      _persist();
    }
  }

  function get(key) {
    return key ? state[key] : Object.assign({}, state);
  }

  function _persist() {
    try {
      localStorage.setItem('bloom_session', JSON.stringify({
        sessionId: state.sessionId,
        cartId: state.cartId,
        lang: state.lang,
        occasionProfile: state.occasionProfile,
        hasSeenExitIntent: state.hasSeenExitIntent
      }));
    } catch {}
  }

  function _applyTheme(theme) {
    var root = document.documentElement;
    if (theme === 'light') {
      root.setAttribute('data-theme', 'light');
    } else {
      root.removeAttribute('data-theme');
    }
  }

  function _initBroadcastChannel() {
    if (typeof BroadcastChannel === 'undefined') return;
    try {
      _bc = new BroadcastChannel('bloom_sync');
      _bc.onmessage = function (e) {
        var msg = e.data;
        if (!msg || !msg.type) return;
        if (msg.type === 'token') {
          state.token = msg.value;
          if (msg.value) localStorage.setItem('bloom_token', msg.value);
          else localStorage.removeItem('bloom_token');
          emit('token', msg.value);
        }
        if (msg.type === 'user') {
          state.user = msg.value;
          if (msg.value) try { localStorage.setItem('bloom_user', JSON.stringify(msg.value)); } catch {}
          else localStorage.removeItem('bloom_user');
          emit('user', msg.value);
        }
        if (msg.type === 'cartCount') {
          state.cartCount = msg.value;
          emit('cartCount', msg.value);
          var badge = document.getElementById('cartBadge');
          if (badge) {
            badge.textContent = msg.value;
            badge.style.display = msg.value > 0 ? 'inline-flex' : 'none';
          }
        }
        if (msg.type === 'theme') {
          state.theme = msg.value;
          _applyTheme(msg.value);
          emit('theme', msg.value);
        }
        if (msg.type === 'logout') {
          state.token = null;
          state.user = null;
          localStorage.removeItem('bloom_token');
          localStorage.removeItem('bloom_user');
          emit('user', null);
          emit('token', null);
        }
      };
    } catch {}
  }

  function _broadcast(msg) {
    if (_bc) {
      try { _bc.postMessage(msg); } catch {}
    }
  }

  function _joinUserRoom() {
    if (!_socket) return;
    var token = state.token || localStorage.getItem('bloom_token');
    if (token) _socket.emit('join_user', token);
  }

  function initSocket() {
    if (typeof io === 'undefined') return;
    if (_socket) return _socket;

    var socketUrl = (window.BLOOM_CONFIG && window.BLOOM_CONFIG.SOCKET_URL)
      || window.location.origin;

    _socket = io(socketUrl, { transports: ['websocket', 'polling'] });

    _socket.on('connect', function () {
      _joinUserRoom();
      var token = state.token || localStorage.getItem('bloom_token');
      if (token && _isAdmin()) {
        _socket.emit('join_admin', token);
      }
    });

    _socket.on('catalog_update', function (data) { emit('catalog_update', data); });
    _socket.on('banner_update', function (data) { emit('banner_update', data); });
    _socket.on('promo_update', function (data) { emit('promo_update', data); });
    _socket.on('content_update', function (data) { emit('content_update', data); });
    _socket.on('faq_update', function (data) { emit('faq_update', data); });
    _socket.on('order_update', function (data) { emit('order_update', data); });

    _socket.on('notification', function (data) {
      emit('notification', data);
      _showNotificationToast(data);
    });

    _socket.on('user_updated', function (data) {
      var current = state.user;
      if (current) {
        var updated = Object.assign({}, current, data);
        state.user = updated;
        try { localStorage.setItem('bloom_user', JSON.stringify(updated)); } catch {}
        emit('user', updated);
        emit('change', state);
      }
    });

    _socket.on('account_deleted', function () {
      localStorage.removeItem('bloom_token');
      localStorage.removeItem('bloom_user');
      state.token = null;
      state.user = null;
      emit('user', null);
      emit('account_deleted', {});
      _broadcast({ type: 'logout' });
      window.location.href = '/?reason=account_removed';
    });

    _socket.on('support_message', function (data) {
      emit('support_message', data);
    });

    window.__BloomSocket = _socket;
    return _socket;
  }

  function _isAdmin() {
    var user = state.user;
    if (user && user.role === 'admin') return true;
    try {
      var stored = JSON.parse(localStorage.getItem('bloom_user') || 'null');
      return stored && stored.role === 'admin';
    } catch { return false; }
  }

  function _showNotificationToast(data) {
    if (!data || !data.title) return;
    var existing = document.getElementById('_storeNotifToast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = '_storeNotifToast';
    el.style.cssText = 'position:fixed;top:24px;right:24px;z-index:999999;background:linear-gradient(135deg,#6366f1,#8b5cf6);color:white;padding:14px 20px;border-radius:14px;font-size:14px;font-weight:600;box-shadow:0 8px 32px rgba(0,0,0,0.4);max-width:320px;cursor:pointer;';
    var safeTitle = String(data.title || '').replace(/[<>&"']/g, '');
    var safeBody = String(data.body || data.message || '').replace(/[<>&"']/g, '');
    el.innerHTML = '<div style="font-size:0.95rem;margin-bottom:2px;">' + safeTitle + '</div>' +
      '<div style="font-size:0.78rem;opacity:0.8;">' + safeBody + '</div>';
    el.addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 5000);
  }

  function init() {
    _initBroadcastChannel();

    try {
      var stored = localStorage.getItem('bloom_session');
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed.sessionId) state.sessionId = parsed.sessionId;
        if (parsed.cartId) state.cartId = parsed.cartId;
        if (parsed.lang) state.lang = parsed.lang;
        if (parsed.occasionProfile) state.occasionProfile = parsed.occasionProfile;
        if (parsed.hasSeenExitIntent) state.hasSeenExitIntent = true;
      }
    } catch {}

    if (!state.sessionId) {
      state.sessionId = 'sess_' + Math.random().toString(36).slice(2) + Date.now();
      _persist();
    }

    var token = localStorage.getItem('bloom_token');
    if (token) {
      state.token = token;
    } else {
      try {
        var localCart = JSON.parse(localStorage.getItem('bloom_cart') || '[]');
        state.cartCount = localCart.reduce(function (s, i) { return s + (i.qty || i.quantity || 1); }, 0);
      } catch {}
    }

    try {
      var storedUser = JSON.parse(localStorage.getItem('bloom_user') || 'null');
      if (storedUser) state.user = storedUser;
    } catch {}

    try {
      state.theme = localStorage.getItem('bloom_theme') || (window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');
    } catch { state.theme = 'dark'; }
    _applyTheme(state.theme);

    try {
      state.recentlyViewed = JSON.parse(localStorage.getItem('bloom_recently_viewed') || '[]');
    } catch { state.recentlyViewed = []; }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSocket);
    } else {
      initSocket();
    }
  }

  function setLang(lang) {
    set('lang', lang);
    _persist();
    document.documentElement.lang = lang;
    document.documentElement.dir = (lang === 'ar' || lang === 'he') ? 'rtl' : 'ltr';
    emit('langChange', lang);
  }

  function setOccasion(occ) {
    set('occasionProfile', occ);
    _persist();
  }

  function updateCartCount(count) {
    var n = Number(count) || 0;
    state.cartCount = n;
    emit('cartCount', n);
    var badge = document.getElementById('cartBadge');
    if (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? 'inline-flex' : 'none';
    }
    _broadcast({ type: 'cartCount', value: n });
  }

  function toggleTheme() {
    set('theme', state.theme === 'dark' ? 'light' : 'dark');
  }

  function addRecentlyViewed(product) {
    if (!product || !product.id) return;
    state.recentlyViewed = state.recentlyViewed.filter(function (p) { return p.id !== product.id; });
    state.recentlyViewed.unshift({
      id: product.id,
      name: product.name,
      image: (product.images && product.images[0]) || product.image || '',
      price: product.base_price || product.price || 0
    });
    if (state.recentlyViewed.length > 10) state.recentlyViewed = state.recentlyViewed.slice(0, 10);
    try { localStorage.setItem('bloom_recently_viewed', JSON.stringify(state.recentlyViewed)); } catch {}
    emit('recentlyViewed', state.recentlyViewed);
  }

  function markExitIntent() {
    state.hasSeenExitIntent = true;
    _persist();
  }

  function setRateLimit(until) {
    state.rateLimitBackoffEnd = until;
    emit('rateLimit', until);
  }

  function joinOrderRoom(orderId) {
    if (_socket && orderId) _socket.emit('join_order', orderId);
  }

  function joinSupportRoom(ticketId) {
    if (_socket && ticketId) _socket.emit('join_support', ticketId);
  }

  function logout() {
    state.token = null;
    state.user = null;
    localStorage.removeItem('bloom_token');
    localStorage.removeItem('bloom_user');
    emit('user', null);
    emit('token', null);
    _broadcast({ type: 'logout' });
    try { fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }); } catch {}
  }

  var Store = {
    on: on,
    emit: emit,
    set: set,
    get: get,
    init: init,
    setLang: setLang,
    setOccasion: setOccasion,
    updateCartCount: updateCartCount,
    toggleTheme: toggleTheme,
    addRecentlyViewed: addRecentlyViewed,
    markExitIntent: markExitIntent,
    setRateLimit: setRateLimit,
    joinOrderRoom: joinOrderRoom,
    joinSupportRoom: joinSupportRoom,
    logout: logout,
    getSocket: function () { return _socket; },
    initSocket: initSocket
  };

  Store.init();
  window.Store = Store;
  window.__BloomStore = Store;
})();

;
  (function () {
    'use strict';
    if (window.Api) return;
    var BASE = ((window.BLOOM_CONFIG && window.BLOOM_CONFIG.API_URL) || window.__BLOOM_API_URL || '/api').replace(/\/+$/, '');
    var _csrfToken = null;
    var _csrfPromise = null;

    function getSocketUrl() {
      if (window.BLOOM_CONFIG && window.BLOOM_CONFIG.SOCKET_URL) return window.BLOOM_CONFIG.SOCKET_URL;
      if (BASE.startsWith('http')) {
        try {
          var u = new URL(BASE);
          return u.origin;
        } catch {}
      }
      return window.location.origin;
    }

    function getHeaders(extra) {
      var h = Object.assign({ 'Content-Type': 'application/json' }, extra || {});
      try {
        var token = (window.Store && window.Store.get('token')) || localStorage.getItem('bloom_token');
        if (token) h['Authorization'] = 'Bearer ' + token;
        var session = window.Store && window.Store.get('sessionId');
        if (session) h['X-Session-Id'] = session;
      } catch {}
      return h;
    }

    function buildUrl(rawPath) {
      var clean = rawPath.replace(/^\/api\//, '').replace(/^\/+/, '');
      return BASE + '/' + clean;
    }

    async function ensureCsrf() {
      if (_csrfToken) return _csrfToken;
      if (_csrfPromise) return _csrfPromise;
      _csrfPromise = (async function () {
        try {
          var res = await fetch(BASE + '/auth/csrf-token', { credentials: 'include' });
          var data = await res.json();
          _csrfToken = data.csrfToken || null;
        } catch (e) {}
        _csrfPromise = null;
        return _csrfToken;
      })();
      return _csrfPromise;
    }

    function isRateLimited() {
      if (window.Store) {
        var end = window.Store.get('rateLimitBackoffEnd');
        if (end && Date.now() < end) return true;
      }
      return false;
    }

    async function request(method, path, body, opts) {
      opts = opts || {};
      if (isRateLimited()) {
        var err429 = new Error('Rate limited. Please wait.');
        err429.status = 429;
        throw err429;
      }
      var url = buildUrl(path);
      var headers = getHeaders(opts.headers || {});
      if (method !== 'GET' && method !== 'HEAD') {
        var csrf = await ensureCsrf();
        if (csrf) headers['X-CSRF-Token'] = csrf;
      }
      var options = { method: method, headers: headers, credentials: 'include' };
      if (body !== undefined && body !== null) options.body = JSON.stringify(body);
      try {
        var res = await fetch(url, options);
        var data;
        try { data = await res.json(); } catch { data = {}; }
        if (!res.ok) {
          if (res.status === 401) {
            const isCritical = path.includes('/auth/me') || path.includes('/auth/logout');
            const isBackground = !!opts.background;
            if (isCritical && !isBackground) {
              try {
                localStorage.removeItem('bloom_token');
                localStorage.removeItem('bloom_user');
                if (window.Store) {
                  window.Store.set('token', null);
                  window.Store.set('user', null);
                }
              } catch {}
            }
            console.warn('[Api] 401 Unauthorized for:', path);
          }
          if (res.status === 429) {
            var retryAfter = res.headers.get('Retry-After');
            var backoffMs = (parseInt(retryAfter, 10) || 60) * 1000;
            var until = Date.now() + backoffMs;
            if (window.Store) window.Store.setRateLimit(until);
          }
          if (res.status === 403 && data && data.error && data.error.indexOf('CSRF') !== -1) {
            _csrfToken = null;
          }
          var errMsg = (data && (data.error || data.message)) || res.statusText || ('HTTP ' + res.status);
          var err = new Error(errMsg);
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      } catch (e) {
        if (!navigator.onLine && method !== 'GET') {
          _queueOfflineMutation(url, method, body);
        }
        throw e;
      }
    }

    function _queueOfflineMutation(url, method, body) {
      try {
        var req = indexedDB.open('bloom_offline', 1);
        req.onupgradeneeded = function () {
          if (!req.result.objectStoreNames.contains('offline_queue')) {
            req.result.createObjectStore('offline_queue', { keyPath: 'id', autoIncrement: true });
          }
        };
        req.onsuccess = function () {
          var db = req.result;
          var tx = db.transaction('offline_queue', 'readwrite');
          tx.objectStore('offline_queue').add({
            url: url,
            method: method,
            body: body,
            timestamp: Date.now()
          });
          if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
            navigator.serviceWorker.ready.then(function (reg) {
              if (reg.sync) reg.sync.register('bloom-sync');
            });
          }
        };
      } catch {}
    }

    async function upload(path, formData, method) {
      method = method || 'POST';
      var h = {};
      try {
        var token = (window.Store && window.Store.get('token')) || localStorage.getItem('bloom_token') || localStorage.getItem('token');
        if (token) h['Authorization'] = 'Bearer ' + token;
        var session = window.Store && window.Store.get('sessionId');
        if (session) h['X-Session-Id'] = session;
        var csrf = await ensureCsrf();
        if (csrf) h['X-CSRF-Token'] = csrf;
      } catch {}
      if (typeof window.Headers !== 'undefined') {
        var hdrs = new Headers();
        for (var k in h) hdrs.append(k, h[k]);
        h = hdrs;
      }
      var res = await fetch(buildUrl(path), { method: method, headers: h, body: formData, credentials: 'include' });
      if (!res.ok) {
        var errData = await res.json().catch(function () { return {}; });
        throw new Error(errData.error || 'Upload failed');
      }
      return res.json();
    }

    window.Api = {
      get: function (path, opts) { return request('GET', path, null, opts); },
      post: function (path, body, opts) { return request('POST', path, body, opts); },
      put: function (path, body, opts) { return request('PUT', path, body, opts); },
      patch: function (path, body, opts) { return request('PATCH', path, body, opts); },
      delete: function (path, opts) { return request('DELETE', path, null, opts); },
      upload: upload,
      getSocketUrl: getSocketUrl,
      baseUrl: BASE,
      clearCsrf: function () { _csrfToken = null; }
    };
    window.__BloomApi = window.Api;
  })();

;
(function () {
  'use strict';
  if (window.__BloomAuth) return;

  var _previousFocus = null;

  function trapFocus(container) {
    var focusable = container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    container._trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    container.addEventListener('keydown', container._trapHandler);
    first.focus();
  }

  function releaseFocus(container) {
    if (container._trapHandler) {
      container.removeEventListener('keydown', container._trapHandler);
      delete container._trapHandler;
    }
    if (_previousFocus && _previousFocus.focus) {
      _previousFocus.focus();
      _previousFocus = null;
    }
  }

  function openModal(modalId) {
    var id = modalId || 'authMod';
    var m = document.getElementById(id);
    if (!m) return;
    _previousFocus = document.activeElement;
    m.classList.add('active');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    var inner = m.querySelector('.modal');
    if (inner) trapFocus(inner);
    m._escHandler = function (e) { if (e.key === 'Escape') closeModal(id); };
    document.addEventListener('keydown', m._escHandler);
  }

  function closeModal(modalId) {
    var id = modalId || 'authMod';
    var m = document.getElementById(id);
    if (!m) return;
    m.classList.remove('active');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    var inner = m.querySelector('.modal');
    if (inner) releaseFocus(inner);
    if (m._escHandler) {
      document.removeEventListener('keydown', m._escHandler);
      delete m._escHandler;
    }
  }

  function setAuthBtn(user) {
    var btn = document.getElementById('authBtn');
    if (!btn) return;
    if (user) {
      btn.textContent = user.name ? user.name.split(' ')[0] : 'Account';
      btn.onclick = function () {
        window.location.href = '/profile.html';
      };
    } else {
      btn.textContent = 'Sign In';
      btn.onclick = function () { openModal('authMod'); };
    }
  }

  async function checkAuth() {
    var token = (window.Store && window.Store.get('token')) || localStorage.getItem('bloom_token');
    if (!token) { setAuthBtn(null); return; }
    try {
      var user = await Api.get('/auth/me');
      Store.set('user', user);
      setAuthBtn(user);
    } catch {
      Store.set('token', null);
      Store.set('user', null);
      setAuthBtn(null);
    }
  }

  function bindAuthTabs() {
    var tabs = document.querySelectorAll('.a-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = tab.dataset.ftab;
        var loginF = document.getElementById('loginF');
        var registerF = document.getElementById('registerF');
        var guestF = document.getElementById('guestF');
        if (loginF) loginF.style.display = target === 'login' ? 'block' : 'none';
        if (registerF) registerF.style.display = target === 'register' ? 'block' : 'none';
        if (guestF) guestF.style.display = target === 'guest' ? 'block' : 'none';
      });
    });
  }

  function bindLogin() {
    var btn = document.getElementById('lSubmit');
    if (!btn) return;
    btn.addEventListener('click', async function () {
      var emailEl = document.getElementById('lEmail');
      var passEl = document.getElementById('lPass');
      var email = emailEl ? emailEl.value.trim() : '';
      var password = passEl ? passEl.value : '';
      if (!email || !password) {
        showAuthToast('Please enter email and password', 'error');
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Signing in...';
      try {
        var res = await Api.post('/auth/login', { email: email, password: password });
        if (res.token) Store.set('token', res.token);
        Store.set('user', res.user);
        setAuthBtn(res.user);
        closeModal('authMod');
        showAuthToast('Welcome back, ' + (res.user.name || 'friend') + '! \uD83C\uDF38', 'success');
      } catch (e) {
        showAuthToast(e.message || 'Login failed', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = 'Sign In →';
      }
    });
  }

  function bindRegister() {
    var btn = document.getElementById('rSubmit');
    if (!btn) return;
    btn.addEventListener('click', async function () {
      var nameEl = document.getElementById('rName');
      var emailEl = document.getElementById('rEmail');
      var passEl = document.getElementById('rPass');
      var name = nameEl ? nameEl.value.trim() : '';
      var email = emailEl ? emailEl.value.trim() : '';
      var password = passEl ? passEl.value : '';
      if (!name || !email || !password) {
        showAuthToast('Please fill all fields', 'error');
        return;
      }
      if (password.length < 8) {
        showAuthToast('Password must be at least 8 characters', 'error');
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Creating account...';
      try {
        var res = await Api.post('/auth/register', { name: name, email: email, password: password });
        if (res.token) Store.set('token', res.token);
        Store.set('user', res.user);
        setAuthBtn(res.user);
        closeModal('authMod');
        showAuthToast('Welcome to Bloom, ' + (res.user.name || 'friend') + '! \uD83C\uDF38', 'success');
      } catch (e) {
        showAuthToast(e.message || 'Registration failed', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = 'Create Account →';
      }
    });
  }

  function bindGuest() {
    var btn = document.getElementById('gSubmit');
    if (!btn) return;
    btn.addEventListener('click', function () {
      closeModal('authMod');
      showAuthToast('Continuing as guest \uD83D\uDC64', 'info');
    });
  }

  function showAuthToast(msg, type) {
    if (window.showToast) { window.showToast(msg, type); return; }
    var existing = document.getElementById('auth-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'auth-toast';
    t.textContent = msg;
    t.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:99999;background:' +
      (type === 'success' ? '#22c55e' : type === 'error' ? '#ef4444' : '#6366f1') +
      ';color:white;padding:12px 24px;border-radius:12px;font-size:14px;font-weight:600;box-shadow:0 4px 20px rgba(0,0,0,0.3);';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 3500);
  }

  function bindPasswordToggles() {
    document.querySelectorAll('.pw-tog').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.for);
        if (!target) return;
        var isPassword = target.type === 'password';
        target.type = isPassword ? 'text' : 'password';
        btn.textContent = isPassword ? 'hide' : 'show';
      });
    });
  }

  function bindPasswordStrength() {
    var passInput = document.getElementById('rPass');
    var fill = document.getElementById('strFill');
    var lbl = document.getElementById('strLbl');
    if (!passInput || !fill) return;
    passInput.addEventListener('input', function () {
      var v = passInput.value;
      var score = 0;
      if (v.length >= 8) score++;
      if (v.length >= 12) score++;
      if (/[A-Z]/.test(v)) score++;
      if (/[0-9]/.test(v)) score++;
      if (/[^A-Za-z0-9]/.test(v)) score++;
      var pct = Math.min(score * 20, 100);
      var color = pct <= 20 ? '#ef4444' : pct <= 40 ? '#f97316' : pct <= 60 ? '#eab308' : pct <= 80 ? '#22c55e' : '#10b981';
      fill.style.width = pct + '%';
      fill.style.background = color;
      if (lbl) lbl.textContent = pct <= 20 ? 'Weak' : pct <= 40 ? 'Fair' : pct <= 60 ? 'Good' : pct <= 80 ? 'Strong' : 'Excellent';
    });
  }

  function bindModals() {
    var pairs = [
      ['authBtn', 'authMod', 'closeAuth'],
      ['fplBtn', 'fplMod', 'closeFpl']
    ];
    pairs.forEach(function (p) {
      var trigger = document.getElementById(p[0]);
      var close = document.getElementById(p[2]);
      var overlay = document.getElementById(p[1]);
      if (trigger && overlay) trigger.addEventListener('click', function () { openModal(p[1]); });
      if (close) close.addEventListener('click', function () { closeModal(p[1]); });
      if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(p[1]); });
    });
  }

  function injectAuthModal() {
    if (document.getElementById('authMod')) return;
    var modalHtml = '<div class="modal-overlay" id="authMod" role="dialog" aria-modal="true" aria-labelledby="authTitle" aria-hidden="true">' +
      '<div class="modal">' +
      '<div class="m-hd">' +
      '<h2 id="authTitle" style="font-family:var(--fd);font-size:1.5rem;font-weight:700">Welcome to Bloom</h2>' +
      '<button class="m-cls" id="closeAuth" aria-label="Close dialog">\u2715</button>' +
      '</div>' +
      '<div class="a-tabs" role="tablist">' +
      '<button class="a-tab active" data-ftab="login" role="tab" aria-selected="true">Sign In</button>' +
      '<button class="a-tab" data-ftab="register" role="tab" aria-selected="false">Register</button>' +
      '<button class="a-tab" data-ftab="guest" role="tab" aria-selected="false">Guest</button>' +
      '</div>' +
      '<div class="err-summary" id="loginErrSum" role="alert" aria-live="assertive" style="display:none">' +
      '<h4>Please fix the following:</h4><ul></ul>' +
      '</div>' +
      '<form id="loginF" onsubmit="event.preventDefault();">' +
      '<button class="btn btn-g sl-btn" id="gBtn">' +
      '<svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>' +
      'Continue with Google</button>' +
      '<div class="div-lbl">or sign in with email</div>' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="lEmail">Email</label>' +
      '<div class="fi-wrap"><input type="email" class="fi-inp" id="lEmail" placeholder="you@example.com" autocomplete="email" required></div>' +
      '</div>' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="lPass">Password</label>' +
      '<div class="fi-wrap">' +
      '<input type="password" class="fi-inp" id="lPass" placeholder="••••••••" autocomplete="current-password" required>' +
      '<button type="button" class="pw-tog" data-for="lPass">show</button>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="fpl-btn" id="fplBtn">Forgot password?</button>' +
      '<button class="btn btn-p" style="width:100%;justify-content:center;margin-top:6px" id="lSubmit">Sign In →</button>' +
      '</form>' +
      '<form id="registerF" style="display:none" onsubmit="event.preventDefault();">' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="rName">Name</label>' +
      '<div class="fi-wrap"><input type="text" class="fi-inp" id="rName" placeholder="Your name" autocomplete="name" required></div>' +
      '</div>' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="rEmail">Email</label>' +
      '<div class="fi-wrap"><input type="email" class="fi-inp" id="rEmail" placeholder="you@example.com" autocomplete="email" required></div>' +
      '</div>' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="rPass">Password</label>' +
      '<div class="fi-wrap">' +
      '<input type="password" class="fi-inp" id="rPass" placeholder="Min 8 characters" autocomplete="new-password" required minlength="8">' +
      '<button type="button" class="pw-tog" data-for="rPass">show</button>' +
      '</div>' +
      '<div id="rStrE" aria-live="polite"><div class="str-bar"><div class="str-fill" id="strFill"></div></div><span class="str-lbl" id="strLbl"></span></div>' +
      '</div>' +
      '<button class="btn btn-p" style="width:100%;justify-content:center;margin-top:6px" id="rSubmit">Create Account →</button>' +
      '</form>' +
      '<div id="guestF" style="display:none;text-align:center;padding:14px 0">' +
      '<p class="m-sub">Browse and pre-order without an account.</p>' +
      '<button class="btn btn-p" style="width:100%;justify-content:center" id="gSubmit">Continue as Guest →</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="modal-overlay" id="fplMod" role="dialog" aria-modal="true" aria-labelledby="fplTitle" aria-hidden="true">' +
      '<div class="modal">' +
      '<div class="m-hd">' +
      '<h2 id="fplTitle" style="font-family:var(--fd);font-size:1.35rem;font-weight:700">Reset Password</h2>' +
      '<button class="m-cls" id="closeFpl" aria-label="Close dialog">\u2715</button>' +
      '</div>' +
      '<p class="m-sub">Enter your email. We\'ll send a secure reset link within 60 seconds.</p>' +
      '<div class="fi">' +
      '<label class="fi-lbl" for="fplEmail">Email</label>' +
      '<div class="fi-wrap"><input type="email" class="fi-inp" id="fplEmail" placeholder="you@example.com" required></div>' +
      '</div>' +
      '<button class="btn btn-p" style="width:100%;justify-content:center" id="fplSubmit">Send Reset Link →</button>' +
      '</div>' +
      '</div>';
    document.body.insertAdjacentHTML('beforeend', modalHtml);
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectAuthModal();
    bindModals();
    bindAuthTabs();
    bindLogin();
    bindRegister();
    bindGuest();
    bindPasswordToggles();
    bindPasswordStrength();
    checkAuth();

    if (window.Store) {
      Store.on('user', function (user) { setAuthBtn(user); });
    }
  });

  window.__BloomAuth = {
    openModal: openModal,
    closeModal: closeModal,
    checkAuth: checkAuth,
    trapFocus: trapFocus,
    releaseFocus: releaseFocus
  };

})();

;
(function () {
  'use strict';
  if (window.I18n) return;

  var dictionaries = {
    en: {
      'nav.shop': 'Shop',
      'nav.catalog': 'Catalog',
      'nav.subscriptions': 'Subscriptions',
      'nav.corporate': 'Corporate',
      'nav.why': 'Why Bloom',
      'nav.custom': 'Create',
      'nav.track': 'Track',
      'nav.support': 'Support',
      'nav.cart': 'Cart',
      'nav.signin': 'Sign In',
      'hero.tagline': 'Handcrafted bouquets, pre-ordered for every moment.',
      'hero.cta': 'Pre-Order Now',
      'hero.catalog': 'Browse Catalog',
      'section.featured': 'Featured Arrangements',
      'section.categories': 'Shop by Category',
      'section.reviews': 'What Customers Say',
      'section.facts': 'Why Bloom?',
      'section.newsletter': 'Stay in Bloom',
      'section.stats': 'By the Numbers',
      'section.recently': 'Recently Viewed',
      'cart.add': 'Add to Cart',
      'cart.view': 'View Cart',
      'cart.empty': 'Your cart is empty',
      'cart.checkout': 'Checkout',
      'auth.login': 'Sign In',
      'auth.register': 'Create Account',
      'auth.guest': 'Continue as Guest',
      'auth.forgot': 'Forgot password?',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.name': 'Name',
      'footer.handcrafted': 'Handcrafted in the Philippines',
      'search.placeholder': 'Search bouquets, gifts...',
      'exit.title': 'Wait! Don\'t leave empty-handed!',
      'exit.subtitle': 'Get 10% off your first order',
      'exit.cta': 'Claim My Discount',
      'exit.dismiss': 'No thanks',
      'theme.toggle': 'Toggle theme'
    },
    fil: {
      'nav.shop': 'Tindahan',
      'nav.catalog': 'Katalogo',
      'nav.subscriptions': 'Mga Subskripsyon',
      'nav.corporate': 'Korporasyon',
      'nav.why': 'Bakit Bloom?',
      'nav.custom': 'Custom',
      'nav.track': 'Subaybayan',
      'nav.support': 'Tulong',
      'nav.cart': 'Kariton',
      'nav.signin': 'Mag-sign In',
      'hero.tagline': 'Mga bouquet na gawa sa kamay, pre-order para sa bawat okasyon.',
      'hero.cta': 'Pre-Order Ngayon',
      'hero.catalog': 'Tingnan ang Katalogo',
      'section.featured': 'Mga Tampok na Ayos',
      'section.categories': 'Tindahan ayon sa Kategorya',
      'section.reviews': 'Ano ang Sabi ng mga Customer',
      'section.facts': 'Bakit Bloom?',
      'section.newsletter': 'Manatiling Namumulaklak',
      'section.stats': 'Sa mga Numero',
      'section.recently': 'Kamakailan Tiningnan',
      'cart.add': 'Idagdag sa Kariton',
      'cart.view': 'Tingnan ang Kariton',
      'cart.empty': 'Walang laman ang iyong kariton',
      'cart.checkout': 'Checkout',
      'auth.login': 'Mag-sign In',
      'auth.register': 'Gumawa ng Account',
      'auth.guest': 'Magpatuloy bilang Bisita',
      'auth.forgot': 'Nakalimutan ang password?',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.name': 'Pangalan',
      'footer.handcrafted': 'Gawa sa kamay sa Pilipinas',
      'search.placeholder': 'Maghanap ng bouquets, regalo...',
      'exit.title': 'Teka! Huwag umalis ng walang dala!',
      'exit.subtitle': '10% diskwento sa unang order mo',
      'exit.cta': 'Kunin ang Diskwento Ko',
      'exit.dismiss': 'Hindi, salamat',
      'theme.toggle': 'Palitan ang tema'
    },
    ja: {
      'nav.shop': 'ショップ',
      'nav.catalog': 'カタログ',
      'nav.subscriptions': 'サブスクリプション',
      'nav.corporate': 'コーポレート',
      'nav.why': 'なぜBloom？',
      'nav.custom': 'カスタム',
      'nav.track': '追跡',
      'nav.support': 'サポート',
      'nav.cart': 'カート',
      'nav.signin': 'ログイン',
      'hero.tagline': 'すべての瞬間のための手作りブーケ。',
      'hero.cta': '今すぐ予約',
      'hero.catalog': 'カタログを見る',
      'section.featured': '特集アレンジメント',
      'section.categories': 'カテゴリーで探す',
      'section.reviews': 'お客様の声',
      'section.facts': 'なぜBloom？',
      'section.newsletter': 'ニュースレター',
      'section.stats': '実績',
      'section.recently': '最近見たもの',
      'cart.add': 'カートに追加',
      'cart.view': 'カートを見る',
      'cart.empty': 'カートは空です',
      'cart.checkout': 'レジに進む',
      'auth.login': 'ログイン',
      'auth.register': 'アカウント作成',
      'auth.guest': 'ゲストとして続ける',
      'auth.forgot': 'パスワードを忘れた？',
      'auth.email': 'メール',
      'auth.password': 'パスワード',
      'auth.name': '名前',
      'footer.handcrafted': 'フィリピンで手作り',
      'search.placeholder': 'ブーケ、ギフトを検索...',
      'exit.title': 'ちょっと待って！',
      'exit.subtitle': '初回注文10%オフ',
      'exit.cta': '割引を受ける',
      'exit.dismiss': 'いいえ、結構です',
      'theme.toggle': 'テーマ切替'
    },
    es: {
      'nav.shop': 'Tienda',
      'nav.catalog': 'Catálogo',
      'nav.subscriptions': 'Suscripciones',
      'nav.corporate': 'Corporativo',
      'nav.why': '¿Por qué Bloom?',
      'nav.custom': 'Personalizar',
      'nav.track': 'Rastrear',
      'nav.support': 'Soporte',
      'nav.cart': 'Carrito',
      'nav.signin': 'Iniciar sesión',
      'hero.tagline': 'Ramos artesanales, pre-ordenados para cada momento.',
      'hero.cta': 'Pre-Ordenar',
      'hero.catalog': 'Ver Catálogo',
      'section.featured': 'Arreglos Destacados',
      'section.categories': 'Comprar por Categoría',
      'section.reviews': 'Lo que Dicen los Clientes',
      'section.facts': '¿Por qué Bloom?',
      'section.newsletter': 'Mantente en Bloom',
      'section.stats': 'En Números',
      'section.recently': 'Vistos Recientemente',
      'cart.add': 'Añadir al Carrito',
      'cart.view': 'Ver Carrito',
      'cart.empty': 'Tu carrito está vacío',
      'cart.checkout': 'Pagar',
      'auth.login': 'Iniciar sesión',
      'auth.register': 'Crear Cuenta',
      'auth.guest': 'Continuar como Invitado',
      'auth.forgot': '¿Olvidaste tu contraseña?',
      'auth.email': 'Correo',
      'auth.password': 'Contraseña',
      'auth.name': 'Nombre',
      'footer.handcrafted': 'Hecho a mano en Filipinas',
      'search.placeholder': 'Buscar ramos, regalos...',
      'exit.title': '¡Espera, no te vayas con las manos vacías!',
      'exit.subtitle': '10% de descuento en tu primer pedido',
      'exit.cta': 'Obtener Descuento',
      'exit.dismiss': 'No, gracias',
      'theme.toggle': 'Cambiar tema'
    }
  };

  var currentLang = 'en';

  function t(key, fallback) {
    var dict = dictionaries[currentLang] || dictionaries.en;
    return dict[key] || (dictionaries.en[key]) || fallback || key;
  }

  function setLang(lang) {
    if (!dictionaries[lang]) lang = 'en';
    currentLang = lang;
    document.documentElement.lang = lang;
    document.documentElement.dir = (lang === 'ar' || lang === 'he') ? 'rtl' : 'ltr';
    applyTranslations();
    if (window.Store) window.Store.setLang(lang);
  }

  function applyTranslations() {
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      var translated = t(key);
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.placeholder = translated;
      } else {
        el.textContent = translated;
      }
    });
    document.querySelectorAll('[data-i18n-aria]').forEach(function (el) {
      el.setAttribute('aria-label', t(el.getAttribute('data-i18n-aria')));
    });
  }

  function formatMoney(amount, currency) {
    currency = currency || 'PHP';
    var lang = currentLang === 'fil' ? 'en-PH' : currentLang;
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(amount);
    } catch {
      return '\u20B1' + Number(amount).toFixed(2);
    }
  }

  function formatDate(date, opts) {
    var lang = currentLang === 'fil' ? 'en-PH' : currentLang;
    try {
      return new Intl.DateTimeFormat(lang, opts || { dateStyle: 'medium' }).format(new Date(date));
    } catch {
      return String(date);
    }
  }

  function getLang() { return currentLang; }
  function getAvailable() { return Object.keys(dictionaries); }

  if (window.Store) {
    currentLang = window.Store.get('lang') || 'en';
  }

  window.I18n = {
    t: t,
    setLang: setLang,
    getLang: getLang,
    getAvailable: getAvailable,
    formatMoney: formatMoney,
    formatDate: formatDate,
    applyTranslations: applyTranslations,
    dictionaries: dictionaries
  };
})();

;

(function () {
  'use strict';
  if (window.Wishlist) return;

  var STORAGE_KEY = 'bloom_wishlist';
  var _items = [];



  function _load() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      _items = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(_items)) _items = [];
    } catch (e) { _items = []; }
  }

  function _save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(_items));
    } catch (e) {}
    _emitUpdate();
  }

  function _emitUpdate() {
    if (window.Store) {
      Store.emit('wishlist', _items);
    }
    _updateBadge();
    _renderDrawer();
  }



  function add(product) {
    if (!product || !product.id) return;
    // Deduplicate
    if (_items.some(function (p) { return String(p.id) === String(product.id); })) return;
    _items.unshift({
      id: product.id,
      name: product.name || product.product_name || 'Product',
      image: _resolveImage(product),
      price: product.base_price || product.price || 0,
      category: product.category || '',
      addedAt: Date.now()
    });
    _save();
  
    _serverAdd(product.id);
  }

  function remove(productId) {
    var before = _items.length;
    _items = _items.filter(function (p) { return String(p.id) !== String(productId); });
    if (_items.length !== before) {
      _save();
      _serverRemove(productId);
    }
  }

  function toggle(product) {
    if (has(product.id)) {
      remove(product.id);
      return false;
    } else {
      add(product);
      return true;
    }
  }

  function has(productId) {
    return _items.some(function (p) { return String(p.id) === String(productId); });
  }

  function getAll() {
    return _items.slice();
  }

  function count() {
    return _items.length;
  }

  function clear() {
    _items = [];
    _save();
  }



  async function _serverAdd(productId) {
    if (!window.Store || !Store.get('user') || !window.Api) return;
    try {
      await Api.post('/products/' + productId + '/wishlist', {});
    } catch (e) { /* silent — localStorage is primary */ }
  }

  async function _serverRemove(productId) {
    if (!window.Store || !Store.get('user') || !window.Api) return;
    try {
      await Api.delete('/products/' + productId + '/wishlist');
    } catch (e) { /* silent */ }
  }

  async function syncFromServer() {
    if (!window.Store || !Store.get('user') || !window.Api) return;
    try {
      var data = await Api.get('/wishlist');
      var serverItems = Array.isArray(data) ? data : (data.items || []);
      if (!serverItems.length) return;
      // Merge server items into local (server wins for items not locally present)
      var localIds = new Set(_items.map(function (p) { return String(p.id); }));
      serverItems.forEach(function (sp) {
        if (!localIds.has(String(sp.product_id || sp.id))) {
          _items.push({
            id: sp.product_id || sp.id,
            name: sp.name || sp.product_name || 'Product',
            image: sp.image || '',
            price: sp.price || sp.base_price || 0,
            category: sp.category || '',
            addedAt: sp.added_at ? new Date(sp.added_at).getTime() : Date.now()
          });
        }
      });
      _save();
    } catch (e) { /* server not available, use local */ }
  }



  function _resolveImage(product) {
    var imgs = product.images || product.image || '';
    if (typeof imgs === 'string') {
      try { imgs = JSON.parse(imgs); } catch (e) { return imgs; }
    }
    if (Array.isArray(imgs) && imgs.length) {
      var flat = imgs.flat(Infinity);
      return typeof flat[0] === 'string' ? flat[0] : '';
    }
    return '';
  }



  function _updateBadge() {
    var badge = document.getElementById('wlCount');
    if (badge) {
      badge.textContent = _items.length;
      badge.style.display = _items.length > 0 ? 'inline-flex' : 'none';
    }
  }

  /* ─── Drawer Rendering ─── */

  function _renderDrawer() {
    var body = document.querySelector('.wl-drawer-body');
    if (!body) return;

    if (!_items.length) {
      body.innerHTML =
        '<div class="wl-empty">' +
        '<div class="wl-empty-ico">♡</div>' +
        '<div style="font-weight:600;margin-bottom:6px;">Your wishlist is empty</div>' +
        '<div style="font-size:.82rem;color:rgba(255,255,255,.5)">Save items you love by tapping the heart icon</div>' +
        '</div>';
      return;
    }

    var fmt = function (n) { return '₱' + Number(n || 0).toFixed(2); };
    body.innerHTML = _items.map(function (p) {
      var safeName = String(p.name || '').replace(/[<>&"']/g, '');
      var safeImg = String(p.image || '').replace(/[<>"]/g, '');
      return '<div class="wl-row" data-id="' + p.id + '">' +
        '<div class="wl-row-img">' +
        (safeImg ? '<img src="' + safeImg + '" alt="' + safeName + '" loading="lazy" onerror="this.onerror=null;this.style.display=\'none\'">' : '') +
        '</div>' +
        '<div class="wl-row-body">' +
        '<div class="wl-row-name">' + safeName + '</div>' +
        '<div class="wl-row-price">' + fmt(p.price) + '</div>' +
        '</div>' +
        '<button class="wl-row-x" data-remove="' + p.id + '" aria-label="Remove ' + safeName + ' from wishlist">✕</button>' +
        '</div>';
    }).join('');

  
    body.querySelectorAll('.wl-row-x').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        remove(btn.dataset.remove);
      });
    });

  
    body.querySelectorAll('.wl-row').forEach(function (row) {
      row.addEventListener('click', function (e) {
        if (e.target.closest('.wl-row-x')) return;
        window.location.href = '/catalog.html?id=' + row.dataset.id;
      });
    });
  }



  function openDrawer() {
    var drawer = document.querySelector('.wl-drawer');
    if (drawer) {
      drawer.classList.add('open');
      document.body.classList.add('modal-open');
      _renderDrawer();
    }
  }

  function closeDrawer() {
    var drawer = document.querySelector('.wl-drawer');
    if (drawer) {
      drawer.classList.remove('open');
      document.body.classList.remove('modal-open');
    }
  }



  function init() {
    _load();
    _updateBadge();


    var openBtn = document.getElementById('wlBtnNav');
    var closeBtn = document.querySelector('.wl-drawer-cls');

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);


    if (window.Store) {
      Store.on('user', function (user) {
        if (user) syncFromServer();
      });
   
      if (Store.get('user')) syncFromServer();
    }
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Wishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    getAll: getAll,
    count: count,
    clear: clear,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    syncFromServer: syncFromServer
  };
  window.__BloomWishlist = window.Wishlist;
})();

;
(function(){
'use strict';
if(window.BloomAnalytics)return;
var _m={};

function _obs(type,cb){
  if(!('PerformanceObserver' in window))return;
  try{var o=new PerformanceObserver(cb);o.observe({type:type,buffered:true});return o;}catch(e){}
}

_obs('largest-contentful-paint',function(l){var e=l.getEntries();if(e.length){_m.lcp=Math.round(e[e.length-1].startTime);_send('LCP',_m.lcp);}});
_obs('first-input',function(l){var e=l.getEntries();if(e.length){_m.fid=Math.round(e[0].processingStart-e[0].startTime);_send('FID',_m.fid);}});

var _cls=0,_sVal=0,_sEntries=[];
_obs('layout-shift',function(l){l.getEntries().forEach(function(e){if(!e.hadRecentInput){var last=_sEntries[_sEntries.length-1];if(_sVal&&last&&e.startTime-last.startTime<1000){_sVal+=e.value;_sEntries.push(e);}else{_sVal=e.value;_sEntries=[e];}if(_sVal>_cls){_cls=_sVal;_m.cls=parseFloat(_cls.toFixed(4));}}});});
document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden'){if(_m.cls!==undefined)_send('CLS',_m.cls);if(_m.inp!==undefined)_send('INP',_m.inp);}});

var _inp=0;
_obs('event',function(l){l.getEntries().forEach(function(e){if(e.duration>_inp){_inp=e.duration;_m.inp=Math.round(_inp);}});});

function _ttfb(){try{var n=performance.getEntriesByType('navigation');if(n&&n.length){_m.ttfb=Math.round(n[0].responseStart-n[0].requestStart);_send('TTFB',_m.ttfb);}}catch(e){}}

function _send(name,val){_ev('web_vital',{metric:name,value:val,url:location.pathname,ts:Date.now()});}

function _ev(type,payload){
  if(!window.Api)return;
  try{
    if(type==='web_vital'&&navigator.sendBeacon){
      try{navigator.sendBeacon((Api.baseUrl||'/api')+'/analytics/event',new Blob([JSON.stringify({eventType:type,payload:payload})],{type:'application/json'}));}catch(e){}
    }else{Api.post('/analytics/event',{eventType:type,payload:payload}).catch(function(){});}
  }catch(e){}
}

var _steps=['hero','shop','cart','checkout','confirmation'];

function trackFunnel(step){
  if(_steps.indexOf(step)===-1)return;
  _ev('funnel_step',{step:step,idx:_steps.indexOf(step),url:location.pathname,ref:document.referrer});
  var bar=document.querySelector('.funnel-bar');
  if(!bar)return;
  var ai=_steps.indexOf(step);
  bar.querySelectorAll('.funnel-step').forEach(function(el,i){el.classList.remove('done','active');if(i<ai)el.classList.add('done');if(i===ai)el.classList.add('active');});
}

function trackPageView(){_ev('page_view',{url:location.pathname+location.search,title:document.title,ref:document.referrer,w:innerWidth,h:innerHeight,dpr:devicePixelRatio||1,conn:(navigator.connection&&navigator.connection.effectiveType)||'unknown'});}
function trackEvent(name,data){_ev(name,Object.assign({url:location.pathname},data||{}));}

function init(){
  trackPageView();
  if(document.readyState==='complete')_ttfb();else window.addEventListener('load',_ttfb);
  var p=location.pathname;
  if(p==='/'||p==='/index.html'){try{var s=document.getElementById('shop');if(s)new IntersectionObserver(function(e){if(e[0].isIntersecting)trackFunnel('shop');},{threshold:0.2}).observe(s);}catch(e){}}
  else if(p.indexOf('catalog')!==-1)trackFunnel('shop');
  else if(p.indexOf('cart')!==-1)trackFunnel('cart');
  else if(p.indexOf('checkout')!==-1)trackFunnel('checkout');
  else if(p.indexOf('confirmation')!==-1)trackFunnel('confirmation');
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.BloomAnalytics={getMetrics:function(){return Object.assign({},_m);},trackEvent:trackEvent,trackFunnel:trackFunnel,trackPageView:trackPageView};
})();

;

(function(){
'use strict';
if(window.BloomTouch)return;

var SWIPE_THRESHOLD=50;
var SWIPE_TIMEOUT=300;

function enableSwipe(container,opts){
  if(!container)return;
  opts=opts||{};
  var startX=0,startY=0,startTime=0,tracking=false;

  container.addEventListener('touchstart',function(e){
    var t=e.touches[0];
    startX=t.clientX;startY=t.clientY;
    startTime=Date.now();tracking=true;
  },{passive:true});

  container.addEventListener('touchmove',function(e){
    if(!tracking)return;
   
    var dx=Math.abs(e.touches[0].clientX-startX);
    var dy=Math.abs(e.touches[0].clientY-startY);
    if(dx>dy&&dx>10){e.preventDefault();}
  },{passive:false});

  container.addEventListener('touchend',function(e){
    if(!tracking)return;
    tracking=false;
    var t=e.changedTouches[0];
    var dx=t.clientX-startX;
    var dy=t.clientY-startY;
    var dt=Date.now()-startTime;
    if(dt>SWIPE_TIMEOUT)return;
    if(Math.abs(dx)<SWIPE_THRESHOLD)return;
    if(Math.abs(dy)>Math.abs(dx))return;

    if(dx<0&&opts.onSwipeLeft)opts.onSwipeLeft();
    if(dx>0&&opts.onSwipeRight)opts.onSwipeRight();
  },{passive:true});
}



function initReviewSwipe(){
  var grid=document.getElementById('reviewsGrid');
  if(!grid)return;
  var cards=grid.querySelectorAll('.rev-card');
  if(cards.length<2)return;
  var current=0;

  function show(idx){
    if(idx<0)idx=cards.length-1;
    if(idx>=cards.length)idx=0;
    current=idx;
    cards.forEach(function(c,i){
      c.classList.toggle('mob-active',i===current);
      c.style.display=(i===current)?'block':'';
    });

    var dots=grid.parentElement.querySelectorAll('.rev-dot');
    dots.forEach(function(d,i){d.classList.toggle('active',i===current);});
  }


  if(window.innerWidth<=900){
    show(0);
  }

  enableSwipe(grid,{
    onSwipeLeft:function(){show(current+1);},
    onSwipeRight:function(){show(current-1);}
  });


  var prev=grid.parentElement.querySelector('.rev-navb:first-of-type');
  var next=grid.parentElement.querySelector('.rev-navb:last-of-type');
  if(prev)prev.addEventListener('click',function(){show(current-1);});
  if(next)next.addEventListener('click',function(){show(current+1);});


  var mql=window.matchMedia('(max-width:900px)');
  mql.addEventListener('change',function(e){
    if(e.matches)show(0);
    else cards.forEach(function(c){c.style.display='';c.classList.remove('mob-active');});
  });
}



function initScrollSwipe(selector){
  var el=document.querySelector(selector);
  if(!el)return;
  enableSwipe(el,{
    onSwipeLeft:function(){el.scrollBy({left:200,behavior:'smooth'});},
    onSwipeRight:function(){el.scrollBy({left:-200,behavior:'smooth'});}
  });
}



function initPullToRefresh(opts){
  opts=opts||{};
  var threshold=opts.threshold||80;
  var onRefresh=opts.onRefresh||function(){location.reload();};
  var startY=0,pulling=false,indicator=null;


  document.addEventListener('touchstart',function(e){
    if(window.scrollY>5)return;
    startY=e.touches[0].clientY;pulling=true;
  },{passive:true});

  document.addEventListener('touchmove',function(e){
    if(!pulling)return;
    var dy=e.touches[0].clientY-startY;
    if(dy<0){pulling=false;return;}
    if(dy>threshold){
      if(!indicator){
        indicator=document.createElement('div');
        indicator.style.cssText='position:fixed;top:0;left:50%;transform:translateX(-50%);z-index:99999;padding:8px 20px;background:rgba(230,26,26,.9);color:#fff;border-radius:0 0 12px 12px;font-size:.78rem;font-weight:600;';
        indicator.textContent='Release to refresh';
        document.body.appendChild(indicator);
      }
    }
  },{passive:true});

  document.addEventListener('touchend',function(){
    if(indicator){
      indicator.textContent='Refreshing...';
      setTimeout(function(){
        if(indicator&&indicator.parentNode)indicator.remove();
        indicator=null;
        onRefresh();
      },400);
    }
    pulling=false;
  },{passive:true});
}



function init(){
  initReviewSwipe();
  initScrollSwipe('#recScroll');
  initScrollSwipe('.cat-tabs');

  var path=location.pathname;
  if(path==='/'||path==='/index.html'){
    initPullToRefresh();
  }
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();

window.BloomTouch={enableSwipe:enableSwipe,initPullToRefresh:initPullToRefresh};
})();

;

(function(){
'use strict';
if(window.BloomFormValidator)return;


function validate(form,rules){
  if(typeof form==='string')form=document.querySelector(form);
  if(!form)return true;
  var errors=[];

  Object.keys(rules).forEach(function(fieldId){
    var rule=rules[fieldId];
    var el=form.querySelector('#'+fieldId)||form.querySelector('[name="'+fieldId+'"]');
    if(!el)return;
    var val=(el.value||'').trim();
    var label=rule.label||_labelFor(el)||fieldId;

 
    el.removeAttribute('aria-invalid');
    var feEl=el.parentElement.querySelector('.fe');
    if(feEl)feEl.textContent='';

 
    if(rule.required&&!val){
      errors.push({field:fieldId,label:label,msg:rule.message||(label+' is required')});
      return;
    }
    if(!val)return;


    if(rule.type==='email'&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)){
      errors.push({field:fieldId,label:label,msg:label+' must be a valid email address'});
      return;
    }


    if(rule.type==='tel'&&!/^[\d\s\-+()]{7,20}$/.test(val)){
      errors.push({field:fieldId,label:label,msg:label+' must be a valid phone number'});
      return;
    }


    if(rule.min&&val.length<rule.min){
      errors.push({field:fieldId,label:label,msg:label+' must be at least '+rule.min+' characters'});
      return;
    }


    if(rule.max&&val.length>rule.max){
      errors.push({field:fieldId,label:label,msg:label+' must be at most '+rule.max+' characters'});
      return;
    }


    if(rule.pattern&&!rule.pattern.test(val)){
      errors.push({field:fieldId,label:label,msg:rule.message||(label+' format is invalid')});
    }
  });

  _renderSummary(form,errors);
  return errors.length===0;
}

function _labelFor(el){

  if(el.id){
    var lbl=document.querySelector('label[for="'+el.id+'"]');
    if(lbl)return lbl.textContent.trim();
  }

  var parent=el.closest('label');
  if(parent){
    var txt=parent.querySelector('.form-label,.fi-lbl');
    if(txt)return txt.textContent.trim();
  }

  var prev=el.parentElement.querySelector('.form-label,.fi-lbl');
  if(prev)return prev.textContent.trim();
  return '';
}

function _renderSummary(form,errors){

  var summary=form.querySelector('.err-summary');
  if(!summary){
    summary=document.createElement('div');
    summary.className='err-summary';
    summary.setAttribute('role','alert');
    summary.setAttribute('aria-live','assertive');
    summary.setAttribute('tabindex','-1');
    form.insertBefore(summary,form.firstChild);
  }

  if(!errors.length){
    summary.classList.remove('on');
    summary.innerHTML='';
    return;
  }


  errors.forEach(function(err){
    var el=form.querySelector('#'+err.field)||form.querySelector('[name="'+err.field+'"]');
    if(el){
      el.setAttribute('aria-invalid','true');
      var feEl=el.parentElement.querySelector('.fe');
      if(feEl)feEl.textContent=err.msg;
    }
  });

 
  summary.innerHTML='<h4>⚠ Please correct '+errors.length+' error'+(errors.length>1?'s':'')+'</h4>'+
    '<ul>'+errors.map(function(err){
      return '<li><a href="#'+err.field+'">'+_escHtml(err.msg)+'</a></li>';
    }).join('')+'</ul>';
  summary.classList.add('on');


  summary.focus();


  summary.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      var target=form.querySelector('#'+a.getAttribute('href').slice(1));
      if(target){target.focus();target.scrollIntoView({behavior:'smooth',block:'center'});}
    });
  });
}

function _escHtml(s){return String(s).replace(/[<>&"']/g,function(c){return{'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":'&#39;'}[c];});}

function clearErrors(form){
  if(typeof form==='string')form=document.querySelector(form);
  if(!form)return;
  var summary=form.querySelector('.err-summary');
  if(summary){summary.classList.remove('on');summary.innerHTML='';}
  form.querySelectorAll('[aria-invalid]').forEach(function(el){el.removeAttribute('aria-invalid');});
  form.querySelectorAll('.fe').forEach(function(el){el.textContent='';});
}

window.BloomFormValidator={validate:validate,clearErrors:clearErrors};
})();

;
(function () {
  'use strict';
  if (window.BloomMotion) return;
  var M = window.Motion || {};
  var animate = M.animate;
  var scroll = M.scroll;
  var inView = M.inView;
  var stagger = M.stagger;
  var spring = M.spring;
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  var _wabiIdx = 0;
  function humanJitter(base) {
    var offsets = [0, 0.018, -0.012, 0.015, -0.008, 0.022, -0.014, 0.01];
    return base + (offsets[_wabiIdx++ % offsets.length]);
  }
  function revealOnScroll(selector, opts) {
    if (reducedMotion() || !inView) return;
    var defaults = { y: [28, 0], opacity: [0, 1] };
    var anim = Object.assign({}, defaults, opts && opts.keyframes);
    var baseDelay = opts && opts.staggerDelay || 0;
    inView(selector, function (info) {
      if (!animate) return;
      var config = { duration: opts && opts.duration || 0.75, easing: opts && opts.easing || [0.22, 1, 0.36, 1] };
      if (baseDelay) {
        config.delay = humanJitter(baseDelay);
      }
      animate(info.target, anim, config);
    }, { margin: opts && opts.margin || '0px 0px -100px 0px' });
  }
  function heroEntrance() {
    if (reducedMotion() || !animate) return;
    var tl = [
      ['.hero-eyebrow', { opacity: [0, 1], x: [-35, 0], filter: ['blur(6px)', 'blur(0px)'] }, { duration: 0.65, easing: [0.22, 1, 0.36, 1] }],
      ['.hero-hl', { opacity: [0, 1], y: [45, 0], filter: ['blur(4px)', 'blur(0px)'] }, { duration: 0.9, easing: [0.22, 1, 0.36, 1], at: 0.12 }],
      ['.hero-sub', { opacity: [0, 1], y: [22, 0] }, { duration: 0.65, easing: [0.22, 1, 0.36, 1], at: 0.25 }],
      ['.hero-cta', { opacity: [0, 1], y: [22, 0], scale: [0.95, 1] }, { duration: 0.55, easing: [0.34, 1.56, 0.64, 1], at: 0.38 }],
      ['.trust', { opacity: [0, 1], y: [14, 0] }, { duration: 0.5, easing: [0.22, 1, 0.36, 1], at: 0.5 }]
    ];
    tl.forEach(function (step) {
      var el = document.querySelector(step[0]);
      if (el) animate(el, step[1], step[2]);
    });
  }
  function fadeUp(selector, options) {
    if (reducedMotion() || !animate) return;
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var config = Object.assign({ duration: 0.65, easing: [0.22, 1, 0.36, 1] }, options);
    animate(els, { opacity: [0, 1], y: [28, 0] }, config);
  }
  function scaleIn(selector, options) {
    if (reducedMotion() || !animate) return;
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var config = Object.assign({ duration: 0.55, easing: [0.34, 1.56, 0.64, 1] }, options);
    animate(els, { opacity: [0, 1], scale: [0.82, 1] }, config);
  }
  function slideIn(selector, direction, options) {
    if (reducedMotion() || !animate) return;
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var kf = { opacity: [0, 1] };
    if (direction === 'left') kf.x = [-45, 0];
    else if (direction === 'right') kf.x = [45, 0];
    else if (direction === 'up') kf.y = [-45, 0];
    else kf.y = [45, 0];
    var config = Object.assign({ duration: 0.65, easing: [0.22, 1, 0.36, 1] }, options);
    animate(els, kf, config);
  }
  function scrollProgress(selector, keyframes, options) {
    if (reducedMotion() || !animate || !scroll) return;
    var el = document.querySelector(selector);
    if (!el) return;
    scroll(
      animate(el, keyframes, { duration: 1, easing: 'linear' }),
      Object.assign({ target: el }, options)
    );
  }
  function staggerCards(selector, options) {
    if (reducedMotion() || !animate || !stagger) return;
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var config = {
      duration: options && options.duration || 0.65,
      delay: stagger(options && options.staggerDelay || 0.07),
      easing: options && options.easing || [0.22, 1, 0.36, 1]
    };
    animate(els, {
      opacity: [0, 1],
      y: [35, 0],
      scale: [0.94, 1]
    }, config);
  }
  function pressEffect(selector) {
    if (reducedMotion() || !animate) return;
    var els = document.querySelectorAll(selector);
    els.forEach(function (el) {
      el.addEventListener('pointerdown', function () {
        animate(el, { scale: 0.95 }, { duration: 0.08, easing: [0.22, 1, 0.36, 1] });
      });
      el.addEventListener('pointerup', function () {
        animate(el, { scale: 1 }, { duration: 0.35, easing: [0.34, 1.56, 0.64, 1] });
      });
      el.addEventListener('pointerleave', function () {
        animate(el, { scale: 1 }, { duration: 0.2 });
      });
    });
  }
  function countUp(el, endValue, options) {
    if (!animate) return;
    var decimal = options && options.decimal;
    var suffix = options && options.suffix || '';
    var obj = { val: 0 };
    animate(obj, { val: endValue }, {
      duration: options && options.duration || 2,
      easing: [0.22, 1, 0.36, 1],
      onUpdate: function () {
        el.textContent = (decimal ? obj.val.toFixed(1) : Math.floor(obj.val).toLocaleString()) + suffix;
      }
    });
  }
  function init() {
    M = window.Motion || {};
    animate = M.animate;
    scroll = M.scroll;
    inView = M.inView;
    stagger = M.stagger;
    spring = M.spring;
    if (!animate) return;
    heroEntrance();
    revealOnScroll('.stat-item', { staggerDelay: 0.05 });
    revealOnScroll('.p-card', {
      keyframes: { y: [35, 0], opacity: [0, 1], scale: [0.95, 1] },
      staggerDelay: 0.06
    });
    revealOnScroll('.feat-card', {
      keyframes: { y: [35, 0], opacity: [0, 1], scale: [0.94, 1] },
      staggerDelay: 0.07,
      duration: 0.75
    });
    revealOnScroll('.rev-card', { staggerDelay: 0.09 });
    revealOnScroll('.fact-card', { staggerDelay: 0.07 });
    revealOnScroll('.subs-card', {
      keyframes: { x: [35, 0], opacity: [0, 1] },
      staggerDelay: 0.09
    });
    revealOnScroll('.team-card', {
      keyframes: { y: [30, 0], opacity: [0, 1], scale: [0.94, 1] },
      staggerDelay: 0.08
    });
    revealOnScroll('.value-card', {
      keyframes: { x: [-30, 0], opacity: [0, 1] },
      staggerDelay: 0.08
    });
    revealOnScroll('.bc-card', {
      keyframes: { y: [30, 0], opacity: [0, 1], scale: [0.95, 1] },
      staggerDelay: 0.06
    });
    pressEffect('.btn-p, .p-add, .cat-tab, .btn-primary, .btn-accent');
    scrollProgress('#sbar', { scaleX: [0, 1] }, {
      target: document.documentElement,
      offset: ['start start', 'end end']
    });
  }
  var BloomMotion = {
    init: init,
    animate: function () { return animate && animate.apply(null, arguments); },
    scroll: function () { return scroll && scroll.apply(null, arguments); },
    inView: function () { return inView && inView.apply(null, arguments); },
    stagger: function () { return stagger && stagger.apply(null, arguments); },
    revealOnScroll: revealOnScroll,
    heroEntrance: heroEntrance,
    fadeUp: fadeUp,
    scaleIn: scaleIn,
    slideIn: slideIn,
    scrollProgress: scrollProgress,
    staggerCards: staggerCards,
    pressEffect: pressEffect,
    countUp: countUp,
    reducedMotion: reducedMotion,
    humanJitter: humanJitter
  };
  window.BloomMotion = BloomMotion;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;
(function () {
  'use strict';
  if (window.BloomCinematicHero) return;
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function init() {
    var container = document.getElementById('cinematicHero');
    if (!container || typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    var mainCard = container.querySelector('.ch-main-card');
    var mockup = container.querySelector('.ch-mockup-bezel');
    var etherealBg = container.querySelector('.ch-ethereal-bg');

    injectEtherealGradientStyle();

    if (!reducedMotion()) {
      var pendingX = 0.5, pendingY = 0.5;
      var clientX = 0, clientY = 0;
      var ticking = false;
      var lastApplied = 0;
      var mockupTween = null;

      function flush() {
        ticking = false;
        if (window.scrollY > window.innerHeight * 2) return;
        var now = performance.now();
        if (now - lastApplied < 16) {
          ticking = true;
          requestAnimationFrame(flush);
          return;
        }
        lastApplied = now;

        if (mainCard) {
          var rect = mainCard.getBoundingClientRect();
          mainCard.style.setProperty('--mouse-x', (clientX - rect.left) + 'px');
          mainCard.style.setProperty('--mouse-y', (clientY - rect.top) + 'px');
        }
        if (etherealBg) {
          etherealBg.style.setProperty('--ch-mx', (pendingX * 100).toFixed(1) + '%');
          etherealBg.style.setProperty('--ch-my', (pendingY * 100).toFixed(1) + '%');
          etherealBg.style.setProperty('--ch-imx', ((1 - pendingX) * 100).toFixed(1) + '%');
          etherealBg.style.setProperty('--ch-imy', ((1 - pendingY) * 100).toFixed(1) + '%');
        }
        if (mockup) {
          var xVal = (pendingX - 0.5) * 2;
          var yVal = (pendingY - 0.5) * 2;
          if (mockupTween) mockupTween.kill();
          mockupTween = gsap.to(mockup, {
            rotationY: xVal * 14,
            rotationX: -yVal * 14,
            ease: 'power3.out',
            duration: 1.4,
            overwrite: 'auto'
          });
        }
      }

      container.addEventListener('mousemove', function (e) {
        if (window.scrollY > window.innerHeight * 2) return;
        clientX = e.clientX;
        clientY = e.clientY;
        pendingX = e.clientX / window.innerWidth;
        pendingY = e.clientY / window.innerHeight;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(flush);
        }
      }, { passive: true });
    }

    if (reducedMotion()) {
      container.querySelectorAll('.ch-gsap-reveal').forEach(function (el) {
        el.style.visibility = 'visible';
        el.style.opacity = '1';
      });
      return;
    }

    var isMobile = window.innerWidth < 768;
    var isSmall = window.innerWidth < 560;
    var q = function (sel) { return container.querySelectorAll(sel); };
    gsap.set(q('.ch-text-track'), { autoAlpha: 0, y: 80, scale: 0.8, filter: 'blur(24px)', rotationX: -25 });
    gsap.set(q('.ch-text-days'), { autoAlpha: 1, clipPath: 'inset(0 100% 0 0)' });
    gsap.set(q('.ch-main-card'), { y: window.innerHeight + 250, autoAlpha: 1 });
    gsap.set(q('.ch-card-left-text, .ch-card-right-text, .ch-mockup-wrapper, .ch-floating-badge, .ch-phone-widget'), { autoAlpha: 0 });
    gsap.set(q('.ch-cta-wrapper'), { autoAlpha: 0, scale: 0.7, filter: 'blur(40px)' });
    gsap.set(q('.ch-bg-frame'), { force3D: true, transformOrigin: '50% 50%', willChange: 'opacity, transform, filter' });
    gsap.set(q('.ch-bg-frame:not(.frame-1)'), { opacity: 0, scale: 1.06, filter: 'brightness(0.45) saturate(0.7) blur(8px)' });
    gsap.set(q('.ch-bg-frame.frame-1'), { filter: 'brightness(1) saturate(1.15) blur(0px)' });

    var introTl = gsap.timeline({ delay: 0.2 });
    introTl
      .to('.ch-text-track', {
        duration: 2.2, autoAlpha: 1, y: 0, scale: 1,
        filter: 'blur(0px)', rotationX: 0,
        ease: 'expo.out', clearProps: 'filter'
      })
      .to('.ch-text-days', {
        duration: 1.6, clipPath: 'inset(0 0% 0 0)',
        ease: 'power4.inOut'
      }, '-=1.2');

    var eyebrowEls = container.querySelectorAll('.ch-hero-text-wrapper .hero-eyebrow, .ch-hero-text-wrapper .tag');
    if (eyebrowEls.length) {
      introTl.fromTo(eyebrowEls, {
        autoAlpha: 0, y: 20, filter: 'blur(8px)'
      }, {
        autoAlpha: 1, y: 0, filter: 'blur(0px)',
        duration: 0.8, ease: 'power3.out', stagger: 0.1, clearProps: 'filter'
      }, '-=0.8');
    }

    var scrollEnd = isMobile ? '+=5400' : '+=7600';
    var scrollTl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: 'top top',
        end: scrollEnd,
        pin: true,
        scrub: 1.2,
        anticipatePin: 1
      }
    });

    scrollTl
      .to('.ch-hero-text-wrapper', { y: -140, scale: 1.1, ease: 'none', duration: 5 }, 0)
      .to('.ch-bg-grid', { scale: 1.3, opacity: 0.12, y: -80, ease: 'none', duration: 5 }, 0)

      .to('.ch-bg-frame.frame-1', { scale: 1.26, y: -70, rotation: 1.8, filter: 'brightness(1.05) saturate(1.2) blur(0.5px)', ease: 'power2.out', duration: 1.6 }, 0)
      .to('.ch-bg-frame.frame-1', { opacity: 0, scale: 1.34, filter: 'brightness(1.2) saturate(1.4) blur(6px)', ease: 'power2.inOut', duration: 1.1 }, 0.7)
      .fromTo('.ch-bg-frame.frame-2',
        { opacity: 0, scale: 1.05, y: 40, rotation: 1.2, filter: 'brightness(0.4) saturate(0.6) blur(10px)' },
        { opacity: 0.94, scale: 1.2, y: -50, rotation: -1.8, filter: 'brightness(1.02) saturate(1.18) blur(0px)', ease: 'expo.out', duration: 1.7 }, 0.7)
      .to('.ch-bg-frame.frame-2', { opacity: 0, scale: 1.3, filter: 'brightness(1.18) saturate(1.35) blur(7px)', ease: 'power2.inOut', duration: 1 }, 1.95)
      .fromTo('.ch-bg-frame.frame-3',
        { opacity: 0, scale: 1.05, y: 40, rotation: -1.5, filter: 'brightness(0.4) saturate(0.6) blur(10px)' },
        { opacity: 0.95, scale: 1.24, y: -82, rotation: 2.8, filter: 'brightness(1.04) saturate(1.22) blur(0px)', ease: 'expo.out', duration: 1.7 }, 1.95)
      .to('.ch-bg-frame.frame-3', { opacity: 0, scale: 1.34, filter: 'brightness(1.2) saturate(1.4) blur(8px)', ease: 'power2.inOut', duration: 1 }, 3.2)
      .fromTo('.ch-bg-frame.frame-4',
        { opacity: 0, scale: 1.05, y: 40, rotation: 1.8, filter: 'brightness(0.4) saturate(0.6) blur(10px)' },
        { opacity: 0.92, scale: 1.27, y: -116, rotation: -2.8, filter: 'brightness(1.03) saturate(1.2) blur(0px)', ease: 'expo.out', duration: 1.7 }, 3.2)
      .to('.ch-bg-frame.frame-4', { opacity: 0, scale: 1.38, filter: 'brightness(1.22) saturate(1.45) blur(9px)', ease: 'power2.inOut', duration: 1 }, 4.45)
      .fromTo('.ch-bg-frame.frame-5',
        { opacity: 0, scale: 1.05, y: 40, rotation: -1, filter: 'brightness(0.35) saturate(0.55) blur(12px)' },
        { opacity: 0.9, scale: 1.32, y: -150, rotation: 1.2, filter: 'brightness(1.06) saturate(1.25) blur(0px)', ease: 'expo.out', duration: 2.1 }, 4.45)

      .to('.ch-hero-text-wrapper', {
        autoAlpha: 0, filter: 'blur(18px)', scale: 1.15,
        ease: 'power2.in', duration: 1.4
      }, 4.2)

      .to('.ch-main-card', {
        y: 0, ease: 'expo.inOut', duration: 2.8
      }, 4)

      .to('.ch-main-card', {
        width: '100%', height: '100%', borderRadius: '0px',
        ease: 'expo.inOut', duration: 1.8
      })

      .fromTo('.ch-mockup-wrapper',
        { y: 350, z: -600, rotationX: 55, rotationY: -35, autoAlpha: 0, scale: 0.5 },
        { y: 0, z: 0, rotationX: 0, rotationY: 0, autoAlpha: 1, scale: 1, ease: 'expo.out', duration: 3 }, '-=1')

      .fromTo('.ch-phone-widget',
        { y: 50, autoAlpha: 0, scale: 0.9 },
        { y: 0, autoAlpha: 1, scale: 1, stagger: 0.12, ease: 'back.out(1.4)', duration: 1.6 }, '-=1.8')

      .to('.ch-progress-ring', { strokeDashoffset: 60, duration: 2.2, ease: 'power3.inOut' }, '-=1.4')
      .to('.ch-counter-val', { innerHTML: 2400, snap: { innerHTML: 1 }, duration: 2.2, ease: 'expo.out' }, '-=2.2')

      .fromTo('.ch-floating-badge',
        { y: 120, autoAlpha: 0, scale: 0.6, rotationZ: -15 },
        { y: 0, autoAlpha: 1, scale: 1, rotationZ: 0, ease: 'back.out(1.7)', duration: 1.8, stagger: 0.18 }, '-=2.2')

      .fromTo('.ch-card-left-text',
        { x: -60, autoAlpha: 0, filter: 'blur(6px)' },
        { x: 0, autoAlpha: 1, filter: 'blur(0px)', ease: 'power4.out', duration: 1.6, clearProps: 'filter' }, '-=1.6')
      .fromTo('.ch-card-right-text',
        { x: 60, autoAlpha: 0, scale: 0.75 },
        { x: 0, autoAlpha: 1, scale: 1, ease: 'expo.out', duration: 1.6 }, '<')

      .to({}, { duration: 2.8 })

      .set('.ch-hero-text-wrapper', { autoAlpha: 0 })
      .set('.ch-cta-wrapper', { autoAlpha: 1 })
      .to({}, { duration: 1.8 })

      .to(['.ch-mockup-wrapper', '.ch-floating-badge', '.ch-card-left-text', '.ch-card-right-text'], {
        scale: 0.85, y: -50, z: -250, autoAlpha: 0,
        ease: 'power3.in', duration: 1.4, stagger: 0.04
      })

      .to('.ch-main-card', {
        width: isSmall ? '94vw' : (isMobile ? '92vw' : '85vw'),
        height: isSmall ? '94vh' : (isMobile ? '92vh' : '85vh'),
        borderRadius: isSmall ? '24px' : (isMobile ? '32px' : '40px'),
        ease: 'expo.inOut',
        duration: 2
      }, 'pullback')

      .to('.ch-cta-wrapper', {
        scale: 1, filter: 'blur(0px)',
        ease: 'expo.inOut', duration: 2, clearProps: 'filter'
      }, 'pullback')

      .addLabel('exit')
      .to('.ch-main-card', {
        y: -window.innerHeight - 350, ease: 'power3.in', duration: 2
      }, 'exit')
      .to('.ch-bg-frame', {
        yPercent: -55, scale: 1.5, filter: 'brightness(1.3) saturate(1.5) blur(12px)', ease: 'power3.in', duration: 2
      }, 'exit')
      .to('.ch-ethereal-bg', {
        yPercent: -18, ease: 'power1.in', duration: 2
      }, 'exit');

    injectAuroraLayer(container);
  }

  function injectEtherealGradientStyle() {
    if (document.getElementById('chEtherealGradientStyle')) return;
    var style = document.createElement('style');
    style.id = 'chEtherealGradientStyle';
    style.textContent =
      '.ch-ethereal-bg{' +
      '--ch-mx:50%;--ch-my:50%;--ch-imx:50%;--ch-imy:50%;' +
      'background-image:' +
      'radial-gradient(circle at var(--ch-mx) var(--ch-my),var(--ethereal-glow-pink,rgba(255,0,255,.25)),transparent 50%),' +
      'radial-gradient(circle at var(--ch-imx) var(--ch-imy),var(--ethereal-glow-red,rgba(230,26,26,.2)),transparent 50%),' +
      'radial-gradient(circle at 50% 50%,hsla(272,100%,10%,.4),transparent 60%);' +
      'transition:background-position 1.6s cubic-bezier(.22,1,.36,1);' +
      'will-change:background-position;' +
      '}';
    document.head.appendChild(style);
  }

  function injectAuroraLayer(container) {
    if (!container || document.getElementById('chAuroraSvg')) return;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = 'chAuroraSvg';
    svg.setAttribute('viewBox', '0 0 1440 600');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.style.cssText = 'position:absolute;bottom:0;left:0;width:100%;height:35%;z-index:2;pointer-events:none;opacity:0.35;mix-blend-mode:screen;';
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    var grad = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
    grad.id = 'auroraGrad';
    grad.setAttribute('x1', '0%'); grad.setAttribute('y1', '0%');
    grad.setAttribute('x2', '100%'); grad.setAttribute('y2', '0%');
    var stops = [
      { offset: '0%', color: 'rgba(124,58,237,0)' },
      { offset: '20%', color: 'rgba(124,58,237,0.6)' },
      { offset: '40%', color: 'rgba(232,67,147,0.5)' },
      { offset: '60%', color: 'rgba(230,26,26,0.4)' },
      { offset: '80%', color: 'rgba(255,215,0,0.3)' },
      { offset: '100%', color: 'rgba(0,212,170,0)' }
    ];
    stops.forEach(function (s) {
      var stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
      stop.setAttribute('offset', s.offset);
      stop.setAttribute('stop-color', s.color);
      grad.appendChild(stop);
    });
    defs.appendChild(grad);

    var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.id = 'auroraBlur';
    var blur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
    blur.setAttribute('stdDeviation', '30');
    filter.appendChild(blur);
    defs.appendChild(filter);
    svg.appendChild(defs);

    for (var i = 0; i < 3; i++) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', 'url(#auroraGrad)');
      path.setAttribute('filter', 'url(#auroraBlur)');
      path.setAttribute('opacity', String(0.5 - i * 0.12));
      path.style.cssText = 'animation:chAuroraWave ' + (12 + i * 4) + 's ease-in-out infinite alternate;transform-origin:center;';
      var yOff = 200 + i * 80;
      path.setAttribute('d', 'M0,' + yOff + ' C360,' + (yOff - 120 + i * 30) + ' 720,' + (yOff + 60 - i * 20) + ' 1080,' + (yOff - 80 + i * 40) + ' S1440,' + (yOff + 40) + ' 1440,' + yOff + ' L1440,600 L0,600 Z');
      svg.appendChild(path);
    }
    var etherealBg = container.querySelector('.ch-ethereal-bg');
    if (etherealBg) {
      etherealBg.appendChild(svg);
    } else {
      container.insertBefore(svg, container.firstChild);
    }

    if (!document.getElementById('chAuroraStyle')) {
      var style = document.createElement('style');
      style.id = 'chAuroraStyle';
      style.textContent = '@keyframes chAuroraWave{0%{transform:translateX(-3%) scaleY(1)}50%{transform:translateX(3%) scaleY(1.15)}100%{transform:translateX(-2%) scaleY(0.9)}}';
      document.head.appendChild(style);
    }
  }

  window.BloomCinematicHero = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;
(function () {
  'use strict';
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) return;
  var recognition = null;
  var listening = false;
  var wantListening = false;
  var fab = null;
  var panel = null;
  var transcript = null;
  var statusEl = null;
  var restartTimeout = null;
  var ROUTES = [
    { patterns: ['home', 'main', 'landing'], url: '/', label: 'Home' },
    { patterns: ['shop', 'browse', 'catalog', 'catalogue', 'flowers', 'bouquets'], url: '/catalog.html', label: 'Catalog' },
    { patterns: ['cart', 'bag', 'basket'], url: '/cart.html', label: 'Cart' },
    { patterns: ['checkout', 'check out', 'pay'], url: '/checkout.html', label: 'Checkout' },
    { patterns: ['customize', 'custom', 'design', 'studio', 'create'], url: '/customize.html', label: 'Customize Studio' },
    { patterns: ['track', 'tracking', 'order status', 'where is'], url: '/tracking.html', label: 'Order Tracking' },
    { patterns: ['support', 'help', 'contact', 'ticket'], url: '/support.html', label: 'Support' },
    { patterns: ['about', 'about us', 'story'], url: '/about.html', label: 'About' },
    { patterns: ['privacy', 'policy'], url: '/privacy.html', label: 'Privacy' },
    { patterns: ['shipping', 'delivery'], url: '/shipping.html', label: 'Shipping' },
    { patterns: ['returns', 'refund'], url: '/returns.html', label: 'Returns' },
    { patterns: ['profile', 'account', 'settings'], url: '/profile.html', label: 'Profile' },
    { patterns: ['subscribe', 'subscription'], url: '/#subs', label: 'Subscriptions' }
  ];
  var ACTIONS = [
    { patterns: ['scroll down', 'go down'], action: function () { window.scrollBy({ top: 400, behavior: 'smooth' }); return 'Scrolling down'; } },
    { patterns: ['scroll up', 'go up', 'top'], action: function () { window.scrollTo({ top: 0, behavior: 'smooth' }); return 'Scrolling to top'; } },
    { patterns: ['dark mode', 'dark theme'], action: function () { document.documentElement.setAttribute('data-theme', 'dark'); return 'Dark mode activated'; } },
    { patterns: ['light mode', 'light theme'], action: function () { document.documentElement.setAttribute('data-theme', 'light'); return 'Light mode activated'; } },
    { patterns: ['search'], action: function (text) { var q = text.replace(/search\s*/i, '').trim(); if (q) { window.location.href = '/catalog.html?search=' + encodeURIComponent(q); return 'Searching for ' + q; } return 'What would you like to search for?'; } },
    { patterns: ['sign in', 'log in', 'login'], action: function () { var btn = document.querySelector('#signInBtn, [data-auth="login"]'); if (btn) btn.click(); return 'Opening sign-in'; } },
    { patterns: ['close', 'stop', 'cancel', 'nevermind'], action: function () { stopListening(); return 'Voice navigation closed'; } }
  ];
  function matchCommand(text) {
    var lower = text.toLowerCase().trim();
    for (var i = 0; i < ACTIONS.length; i++) {
      for (var j = 0; j < ACTIONS[i].patterns.length; j++) {
        if (lower.indexOf(ACTIONS[i].patterns[j]) !== -1) {
          return { type: 'action', item: ACTIONS[i], text: lower };
        }
      }
    }
    for (var k = 0; k < ROUTES.length; k++) {
      for (var m = 0; m < ROUTES[k].patterns.length; m++) {
        if (lower.indexOf(ROUTES[k].patterns[m]) !== -1) {
          return { type: 'route', item: ROUTES[k] };
        }
      }
    }
    return null;
  }
  function setStatus(msg, type) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = 'vn-status vn-status-' + (type || 'info');
  }
  function setTranscript(text) {
    if (transcript) transcript.textContent = text || '\u2026';
  }
  function showToast(msg) {
    if (window.showToast) window.showToast(msg, 'info');
  }
  function createRecognition() {
    var rec = new SpeechRecognition();
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = navigator.language || 'en-US';
    rec.maxAlternatives = 1;
    rec.onstart = function () {
      listening = true;
      if (fab) fab.classList.add('vn-active');
      var navBtn = document.getElementById('voiceNavBtn');
      if (navBtn) {
        navBtn.classList.add('listening');
        navBtn.setAttribute('aria-pressed', 'true');
      }
      if (panel) panel.classList.add('vn-panel-open');
      setStatus('Listening\u2026', 'listening');
      setTranscript('');
    };
    rec.onresult = function (e) {
      var interim = '';
      var finalText = '';
      for (var i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) {
          finalText += e.results[i][0].transcript;
        } else {
          interim += e.results[i][0].transcript;
        }
      }
      setTranscript(finalText || interim);
      if (finalText) processCommand(finalText);
    };
    rec.onerror = function (e) {
      var err = e.error || 'unknown';
      if (err === 'aborted') return;
      if (err === 'no-speech') {
        setStatus('No speech detected — try again', 'warn');
        if (wantListening) scheduleRestart();
      } else if (err === 'not-allowed') {
        setStatus('Microphone access denied', 'error');
        wantListening = false;
        updateUIState(false);
      } else if (err === 'network') {
        setStatus('Network error — speech recognition requires a connection', 'error');
        wantListening = false;
        updateUIState(false);
      } else {
        setStatus('Error: ' + err, 'error');
        if (wantListening) scheduleRestart();
      }
    };
    rec.onend = function () {
      listening = false;
      if (wantListening) {
        scheduleRestart();
      } else {
        updateUIState(false);
        setTimeout(function () {
          if (!wantListening && panel) {
            panel.classList.remove('vn-panel-open');
          }
        }, 3000);
      }
    };
    return rec;
  }
  function scheduleRestart() {
    clearTimeout(restartTimeout);
    restartTimeout = setTimeout(function () {
      if (!wantListening) return;
      try {
        if (recognition) {
          try { recognition.stop(); } catch (_) {}
        }
        recognition = createRecognition();
        recognition.start();
      } catch (err) {
        setStatus('Could not restart — tap mic to retry', 'warn');
        wantListening = false;
        updateUIState(false);
      }
    }, 300);
  }
  function updateUIState(active) {
    if (fab) {
      if (active) fab.classList.add('vn-active');
      else fab.classList.remove('vn-active');
    }
    var navBtn = document.getElementById('voiceNavBtn');
    if (navBtn) {
      if (active) {
        navBtn.classList.add('listening');
        navBtn.setAttribute('aria-pressed', 'true');
      } else {
        navBtn.classList.remove('listening');
        navBtn.setAttribute('aria-pressed', 'false');
      }
    }
  }
  function startListening() {
    if (wantListening) return;
    wantListening = true;
    clearTimeout(restartTimeout);
    try {
      if (recognition) {
        try { recognition.stop(); } catch (_) {}
      }
      recognition = createRecognition();
      recognition.start();
    } catch (err) {
      setStatus('Could not start speech recognition', 'error');
      wantListening = false;
      updateUIState(false);
    }
  }
  function stopListening() {
    wantListening = false;
    clearTimeout(restartTimeout);
    if (recognition) {
      try { recognition.stop(); } catch (_) {}
    }
    listening = false;
    updateUIState(false);
    if (panel) panel.classList.remove('vn-panel-open');
  }
  function processCommand(text) {
    var match = matchCommand(text);
    if (!match) {
      setStatus('Command not recognized', 'warn');
      showToast('\uD83C\uDF99\uFE0F "' + text + '" \u2014 try: shop, cart, customize, track, support');
      return;
    }
    if (match.type === 'route') {
      setStatus('Navigating to ' + match.item.label + '\u2026', 'success');
      showToast('\uD83C\uDF99\uFE0F Navigating to ' + match.item.label);
      stopListening();
      setTimeout(function () { window.location.href = match.item.url; }, 600);
    } else if (match.type === 'action') {
      var result = match.item.action(text);
      setStatus(result, 'success');
      showToast('\uD83C\uDF99\uFE0F ' + result);
    }
  }
  function createUI() {
    fab = document.createElement('button');
    fab.id = 'voiceNavFab';
    fab.className = 'vn-fab';
    fab.setAttribute('aria-label', 'Voice navigation');
    fab.setAttribute('title', 'Voice navigation \u2014 W3C Web Speech API');
    fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>';
    panel = document.createElement('div');
    panel.className = 'vn-panel';
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
    panel.innerHTML =
      '<div class="vn-panel-hd">' +
        '<span class="vn-panel-title">\uD83C\uDF99\uFE0F Voice Navigation</span>' +
        '<span class="vn-api-tag">W3C Web Speech API</span>' +
      '</div>' +
      '<div class="vn-transcript" id="vnTranscript">\u2026</div>' +
      '<div class="vn-status" id="vnStatus">Tap mic to start</div>' +
      '<div class="vn-cmds">' +
        '<span>shop</span><span>cart</span><span>customize</span><span>track</span><span>support</span><span>search \u2026</span><span>dark mode</span><span>scroll up</span>' +
      '</div>';
    document.body.appendChild(panel);
    document.body.appendChild(fab);
    transcript = document.getElementById('vnTranscript');
    statusEl = document.getElementById('vnStatus');
    fab.addEventListener('click', function () {
      if (wantListening) { stopListening(); } else { startListening(); }
    });
    var navBtn = document.getElementById('voiceNavBtn');
    if (navBtn) {
      navBtn.hidden = false;
      navBtn.addEventListener('click', function () {
        if (wantListening) { stopListening(); } else { startListening(); }
      });
    }
  }
  function injectStyles() {
    if (document.getElementById('vnStyles')) return;
    var s = document.createElement('style');
    s.id = 'vnStyles';
    s.textContent =
      '.vn-fab{position:fixed;bottom:88px;right:28px;width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,var(--p5d,#A81010),var(--p5,#E61A1A));color:#fff;border:none;display:flex;align-items:center;justify-content:center;z-index:999;box-shadow:0 6px 24px rgba(230,26,26,.35);transition:all .3s cubic-bezier(.23,1,.32,1);cursor:pointer}' +
      '.vn-fab svg{width:22px;height:22px}' +
      '.vn-fab:hover{transform:translateY(-3px);box-shadow:0 10px 32px rgba(230,26,26,.5)}' +
      '.vn-fab.vn-active{background:linear-gradient(135deg,#ff3b3b,#e61a1a);animation:vn-pulse 1.2s ease-in-out infinite}' +
      '@keyframes vn-pulse{0%,100%{box-shadow:0 0 0 0 rgba(230,26,26,.5)}50%{box-shadow:0 0 0 14px rgba(230,26,26,0)}}' +
      '.vn-panel{position:fixed;bottom:148px;right:28px;width:280px;background:rgba(11,5,22,.92);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border:1px solid rgba(255,255,255,.08);border-radius:16px;padding:16px;z-index:998;opacity:0;transform:translateY(12px) scale(.95);pointer-events:none;transition:all .3s cubic-bezier(.23,1,.32,1)}' +
      '.vn-panel-open{opacity:1;transform:translateY(0) scale(1);pointer-events:all}' +
      '.vn-panel-hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}' +
      '.vn-panel-title{font-weight:700;font-size:.82rem;color:#fff}' +
      '.vn-api-tag{font-size:.58rem;padding:2px 7px;border-radius:4px;background:rgba(0,212,170,.1);border:1px solid rgba(0,212,170,.2);color:rgba(0,212,170,.8);font-weight:600;letter-spacing:.04em}' +
      '.vn-transcript{font-size:1rem;font-weight:600;color:#fff;min-height:28px;margin-bottom:8px;word-break:break-word}' +
      '.vn-status{font-size:.72rem;margin-bottom:10px;transition:color .2s}' +
      '.vn-status-info{color:rgba(255,255,255,.45)}' +
      '.vn-status-listening{color:rgba(230,26,26,.9)}' +
      '.vn-status-success{color:rgba(0,212,170,.9)}' +
      '.vn-status-warn{color:rgba(255,215,0,.8)}' +
      '.vn-status-error{color:rgba(255,59,59,.9)}' +
      '.vn-cmds{display:flex;flex-wrap:wrap;gap:4px}' +
      '.vn-cmds span{font-size:.62rem;padding:3px 8px;border-radius:6px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.08);color:rgba(255,255,255,.45);letter-spacing:.03em}' +
      '[data-theme="light"] .vn-panel{background:rgba(255,255,255,.95);border-color:rgba(0,0,0,.1)}' +
      '[data-theme="light"] .vn-panel-title{color:#1A1220}' +
      '[data-theme="light"] .vn-transcript{color:#1A1220}' +
      '[data-theme="light"] .vn-cmds span{background:rgba(0,0,0,.04);border-color:rgba(0,0,0,.08);color:rgba(26,18,32,.5)}' +
      '@media(max-width:480px){.vn-panel{right:12px;left:12px;width:auto;bottom:140px}.vn-fab{bottom:80px;right:16px;width:44px;height:44px}}';
    document.head.appendChild(s);
  }
  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    createUI();
  });
})();

;
(function () {
  'use strict';
  if (!window.MediaRecorder || !navigator.mediaDevices) return;

  var stream = null;
  var recorder = null;
  var chunks = [];
  var videoBlob = null;
  var recordingTimer = null;
  var elapsed = 0;
  var MAX_SECONDS = 30;
  var currentObjectUrl = null;
  var pickedMime = '';

  window.BloomVideoMessage = {
    getBlobAsync: function () {
      return new Promise(function (resolve) {
        if (recorder && recorder.state !== 'inactive') {
          var done = false;
          var resolver = function () { if (done) return; done = true; resolve(videoBlob); };
          recorder.addEventListener('stop', resolver, { once: true });
          try { recorder.requestData(); } catch (e) {}
          try { recorder.stop(); } catch (e) {}
          setTimeout(resolver, 2500);
        } else {
          resolve(videoBlob);
        }
      });
    },
    getBlob: function () { return videoBlob; },
    getMime: function () { return pickedMime || 'video/webm'; },
    getExtension: function () {
      var m = (pickedMime || 'video/webm').toLowerCase();
      if (m.indexOf('mp4') !== -1) return 'mp4';
      if (m.indexOf('ogg') !== -1) return 'ogg';
      return 'webm';
    },
    reset: function () { videoBlob = null; revokeUrl(); updatePreview(); showControls('start'); },
    attachTo: function (containerId) {
      var host = document.getElementById(containerId);
      if (!host || host.dataset.vmInit) return;
      host.dataset.vmInit = '1';
      injectStyles();
      host.innerHTML = buildUI();
      bindEvents(host);
    },
    forceStop: function () {
      if (recorder && recorder.state !== 'inactive') stopRecording();
    }
  };

  function revokeUrl() {
    if (currentObjectUrl) {
      try { URL.revokeObjectURL(currentObjectUrl); } catch (e) {}
      currentObjectUrl = null;
    }
  }

  function buildUI() {
    return '' +
      '<div class="vm-wrap">' +
        '<div class="vm-hd">' +
          '<span class="vm-title">\uD83C\uDFA5 Video Greeting</span>' +
          '<span class="vm-api-tag">MediaRecorder</span>' +
        '</div>' +
        '<div class="vm-stage">' +
          '<video class="vm-preview" id="vmPreview" playsinline muted></video>' +
          '<video class="vm-playback" id="vmPlayback" playsinline style="display:none"></video>' +
          '<div class="vm-overlay" id="vmOverlay">' +
            '<div class="vm-rec-dot"></div>' +
            '<div class="vm-timer" id="vmTimer">0:00</div>' +
          '</div>' +
          '<div class="vm-placeholder" id="vmPlaceholder">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:32px;height:32px;opacity:.4"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>' +
            '<span>Record a personal video greeting</span>' +
            '<span class="vm-note">Up to 30 seconds \u00b7 Camera + microphone required</span>' +
          '</div>' +
        '</div>' +
        '<div class="vm-controls">' +
          '<button type="button" class="vm-btn vm-btn-start" id="vmStart">\u25CF Record</button>' +
          '<button type="button" class="vm-btn vm-btn-stop" id="vmStop" style="display:none">\u25A0 Stop</button>' +
          '<button type="button" class="vm-btn vm-btn-retake" id="vmRetake" style="display:none">Retake</button>' +
          '<button type="button" class="vm-btn vm-btn-accept" id="vmAccept" style="display:none">Attach</button>' +
        '</div>' +
      '</div>';
  }

  function bindEvents(host) {
    host.querySelector('#vmStart').addEventListener('click', startRecording);
    host.querySelector('#vmStop').addEventListener('click', stopRecording);
    host.querySelector('#vmRetake').addEventListener('click', function () {
      videoBlob = null;
      revokeUrl();
      updatePreview();
      showControls('start');
    });
    host.querySelector('#vmAccept').addEventListener('click', function () {
      if (!videoBlob || videoBlob.size === 0) return;
      showControls('done');
      if (window.showToast) window.showToast('\uD83C\uDFA5 Video greeting attached', 'success');
      var event = new CustomEvent('bloom:video-attached', { detail: { blob: videoBlob, size: videoBlob.size } });
      document.dispatchEvent(event);
    });
  }

  function showControls(state) {
    var startBtn = document.getElementById('vmStart');
    var stopBtn = document.getElementById('vmStop');
    var retakeBtn = document.getElementById('vmRetake');
    var acceptBtn = document.getElementById('vmAccept');
    if (!startBtn) return;
    startBtn.style.display = state === 'start' ? '' : 'none';
    stopBtn.style.display = state === 'recording' ? '' : 'none';
    retakeBtn.style.display = (state === 'review' || state === 'done') ? '' : 'none';
    acceptBtn.style.display = state === 'review' ? '' : 'none';
  }

  async function startRecording() {
    var preview = document.getElementById('vmPreview');
    var placeholder = document.getElementById('vmPlaceholder');
    var overlay = document.getElementById('vmOverlay');
    var playback = document.getElementById('vmPlayback');

    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } },
        audio: true
      });
    } catch (e) {
      if (window.showToast) window.showToast('Camera access denied or unavailable', 'error');
      return;
    }

    videoBlob = null;
    revokeUrl();
    if (preview) {
      preview.srcObject = stream;
      preview.style.display = 'block';
      preview.play().catch(function () {});
    }
    if (playback) {
      try { playback.pause(); } catch (e) {}
      playback.removeAttribute('src');
      try { playback.load(); } catch (e) {}
      playback.style.display = 'none';
    }
    if (placeholder) placeholder.style.display = 'none';
    if (overlay) overlay.style.display = 'flex';

    chunks = [];
    var candidates = [
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
      'video/webm',
      'video/mp4;codecs=avc1,mp4a',
      'video/mp4'
    ];
    pickedMime = '';
    for (var i = 0; i < candidates.length; i++) {
      if (MediaRecorder.isTypeSupported(candidates[i])) {
        pickedMime = candidates[i];
        break;
      }
    }

    var options = pickedMime ? { mimeType: pickedMime } : undefined;
    recorder = new MediaRecorder(stream, options);
    recorder.ondataavailable = function (e) { if (e.data && e.data.size > 0) chunks.push(e.data); };
    recorder.onerror = function (e) {
      if (window.showToast) window.showToast('Recording error: ' + (e.error && e.error.name || 'unknown'), 'error');
    };
    recorder.onstop = function () {
      var blobType = pickedMime && pickedMime.split(';')[0] ? pickedMime.split(';')[0] : 'video/webm';
      videoBlob = new Blob(chunks, { type: blobType });
      stopStream();
      setTimeout(function () { updatePreview(); showControls('review'); }, 60);
    };

    try { recorder.start(250); } catch (e) { recorder.start(); }
    elapsed = 0;
    updateTimer();
    recordingTimer = setInterval(function () {
      elapsed++;
      updateTimer();
      if (elapsed >= MAX_SECONDS) stopRecording();
    }, 1000);
    showControls('recording');
  }

  function stopRecording() {
    if (recordingTimer) { clearInterval(recordingTimer); recordingTimer = null; }
    if (recorder && recorder.state !== 'inactive') {
      try { recorder.requestData(); } catch (e) {}
      try { recorder.stop(); } catch (e) {}
    }
    var overlay = document.getElementById('vmOverlay');
    if (overlay) overlay.style.display = 'none';
  }

  function stopStream() {
    if (stream) {
      try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
      stream = null;
    }
    var preview = document.getElementById('vmPreview');
    if (preview) {
      try { preview.pause(); } catch (e) {}
      preview.srcObject = null;
      preview.removeAttribute('src');
      try { preview.load(); } catch (e) {}
      preview.style.display = 'none';
    }
  }

  function updateTimer() {
    var el = document.getElementById('vmTimer');
    if (!el) return;
    var m = Math.floor(elapsed / 60);
    var s = elapsed % 60;
    el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    var remaining = MAX_SECONDS - elapsed;
    if (remaining <= 5) el.style.color = 'rgba(230,26,26,.9)';
    else el.style.color = '#fff';
  }

  function updatePreview() {
    var playback = document.getElementById('vmPlayback');
    var placeholder = document.getElementById('vmPlaceholder');
    var preview = document.getElementById('vmPreview');

    if (!playback) return;
    if (videoBlob && videoBlob.size > 0) {
      revokeUrl();
      currentObjectUrl = URL.createObjectURL(videoBlob);
      if (preview) preview.style.display = 'none';
      if (placeholder) placeholder.style.display = 'none';

      playback.style.display = 'block';
      playback.muted = false;
      playback.controls = true;
      playback.setAttribute('controls', 'controls');
      playback.setAttribute('playsinline', 'playsinline');
      playback.src = currentObjectUrl;

      var onReady = function () {
        playback.removeEventListener('loadedmetadata', onReady);
        try { playback.currentTime = 0; } catch (e) {}
      };
      playback.addEventListener('loadedmetadata', onReady);
      try { playback.load(); } catch (e) {}
    } else {
      try { playback.pause(); } catch (e) {}
      playback.removeAttribute('src');
      try { playback.load(); } catch (e) {}
      playback.style.display = 'none';
      revokeUrl();
      if (preview) preview.style.display = 'none';
      if (placeholder) placeholder.style.display = 'flex';
    }
  }

  function injectStyles() {
    if (document.getElementById('vmStyles')) return;
    var s = document.createElement('style');
    s.id = 'vmStyles';
    s.textContent =
      '.vm-wrap{border:1px solid rgba(255,255,255,.08);border-radius:16px;overflow:hidden;background:rgba(255,255,255,.03)}' +
      '.vm-hd{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid rgba(255,255,255,.06)}' +
      '.vm-title{font-weight:700;font-size:.82rem}' +
      '.vm-api-tag{font-size:.58rem;padding:2px 7px;border-radius:4px;background:rgba(56,189,248,.1);border:1px solid rgba(56,189,248,.2);color:rgba(56,189,248,.85);font-weight:600;letter-spacing:.04em}' +
      '.vm-stage{position:relative;aspect-ratio:16/9;background:#000;overflow:hidden}' +
      '.vm-preview{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:1;background:#000;transform:scaleX(-1)}' +
      '.vm-playback{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000;z-index:5}' +
      '.vm-placeholder{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;color:rgba(255,255,255,.55);font-size:.84rem;text-align:center;padding:20px;z-index:2}' +
      '.vm-note{font-size:.68rem;color:rgba(255,255,255,.3)}' +
      '.vm-overlay{position:absolute;top:12px;left:12px;display:none;align-items:center;gap:8px;padding:5px 12px;border-radius:100px;background:rgba(230,26,26,.92);backdrop-filter:blur(8px);z-index:6;color:#fff;font-weight:700;font-size:.72rem;letter-spacing:.1em}' +
      '.vm-timer{font-variant-numeric:tabular-nums}' +
      '.vm-rec-dot{width:8px;height:8px;border-radius:50%;background:#fff;animation:vm-blink 1s ease-in-out infinite}' +
      '@keyframes vm-blink{0%,100%{opacity:1}50%{opacity:.3}}' +
      '.vm-controls{display:flex;gap:8px;padding:12px 16px}' +
      '.vm-btn{flex:1;padding:9px 14px;border-radius:10px;font-size:.82rem;font-weight:700;border:none;cursor:pointer;transition:all .2s;font-family:inherit}' +
      '.vm-btn-start{background:linear-gradient(135deg,#a81010,#e61a1a);color:#fff}' +
      '.vm-btn-start:hover{box-shadow:0 4px 16px rgba(230,26,26,.4);transform:translateY(-1px)}' +
      '.vm-btn-stop{background:rgba(230,26,26,.15);color:#ff3b3b;border:1px solid rgba(230,26,26,.3)}' +
      '.vm-btn-retake{background:rgba(255,255,255,.06);color:rgba(255,255,255,.78);border:1px solid rgba(255,255,255,.1)}' +
      '.vm-btn-accept{background:linear-gradient(135deg,#00a882,#00d4aa);color:#fff}' +
      '.vm-btn-accept:hover{box-shadow:0 4px 16px rgba(0,212,170,.4);transform:translateY(-1px)}' +
      '[data-theme="light"] .vm-wrap{background:rgba(0,0,0,.02);border-color:rgba(0,0,0,.08)}' +
      '[data-theme="light"] .vm-hd{border-bottom-color:rgba(0,0,0,.06)}' +
      '[data-theme="light"] .vm-placeholder{color:rgba(26,18,32,.55)}' +
      '[data-theme="light"] .vm-note{color:rgba(26,18,32,.35)}' +
      '[data-theme="light"] .vm-btn-retake{background:rgba(0,0,0,.04);color:rgba(26,18,32,.78);border-color:rgba(0,0,0,.1)}';
    document.head.appendChild(s);
  }
})();

;
(function () {
  'use strict';
  var QR_API = 'https://api.qrserver.com/v1/create-qr-code/';
  var CHAIN_STAGES = [
    { id: 'harvest', icon: '\uD83C\uDF3F', label: 'Farm Harvest', location: 'Bagong Pook, Lipa City, Batangas', desc: 'Hand-picked at optimal bloom stage by local growers', temp: '22\u00b0C ambient', time: '-48h', verifier: 'Grower cooperative log' },
    { id: 'qc', icon: '\uD83D\uDD2C', label: 'Quality Inspection', location: 'Processing Hub, Lipa City', desc: 'Stem hydration test, petal integrity check, pest screening', temp: '4\u00b0C cold room', time: '-36h', verifier: 'QC station sensor' },
    { id: 'arrange', icon: '\u2702\uFE0F', label: 'Arrangement', location: 'Bloom Studio, Lipa City', desc: 'Hand-arranged by trained florist per order specs', temp: '8\u00b0C workspace', time: '-12h', verifier: 'Florist workstation ID' },
    { id: 'pack', icon: '\uD83D\uDCE6', label: 'Packaging', location: 'Bloom Fulfillment, Lipa City', desc: 'Insulated box, gel pack, moisture seal applied', temp: '4\u00b0C staging', time: '-4h', verifier: 'Pack station barcode' },
    { id: 'transit', icon: '\uD83D\uDE9A', label: 'In Transit', location: 'Route to delivery area', desc: 'Temperature-monitored vehicle dispatched', temp: '2-6\u00b0C vehicle', time: '-2h', verifier: 'Vehicle GPS + temp logger' },
    { id: 'deliver', icon: '\uD83C\uDF38', label: 'Delivered', location: 'Recipient address', desc: 'Photo proof captured, recipient confirmed', temp: 'Ambient', time: '0h', verifier: 'Delivery photo timestamp' }
  ];
  var FARMS = [
    { name: 'Bagong Pook Highland Garden', crop: 'Roses, Chrysanthemums', altitude: '350m', status: 'Active growing season', lat: 13.94, lon: 121.16, region: 'Lipa City, Batangas' },
    { name: 'San Jose Orchid Nursery', crop: 'Dendrobium Orchids, Lilies', altitude: '280m', status: 'Controlled greenhouse', lat: 13.93, lon: 121.15, region: 'Lipa City, Batangas' },
    { name: 'Mataas na Kahoy Flower Farm', crop: 'Sunflowers, Gerbera', altitude: '420m', status: 'Peak harvest', lat: 13.97, lon: 121.09, region: 'Batangas Province' }
  ];

  window.BloomSupplyChain = {
    renderTraceability: renderTraceability,
    generateQR: generateQR
  };

  function generateQR(data, size) {
    size = size || 180;
    return QR_API + '?size=' + size + 'x' + size + '&margin=6&data=' + encodeURIComponent(data);
  }

  function buildTraceabilityURL(productId) {
    return window.location.origin + '/tracking.html?id=' + encodeURIComponent(productId || 'BLOOM');
  }

  async function generateIntegrityHash(dataStr) {
    if (window.crypto && window.crypto.subtle) {
      try {
        var encoder = new TextEncoder();
        var data = encoder.encode(dataStr);
        var hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
        var hashArray = Array.from(new Uint8Array(hashBuffer));
        var hashHex = hashArray.map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
        return '0x' + hashHex.substring(0, 16) + '\u2026';
      } catch (e) { }
    }
    var hash = 0;
    for (var i = 0; i < dataStr.length; i++) {
      hash = ((hash << 5) - hash) + dataStr.charCodeAt(i);
      hash |= 0;
    }
    return '0x' + Math.abs(hash).toString(16) + '\u2026';
  }

  async function renderTraceability(containerId, productId) {
    var host = document.getElementById(containerId);
    if (!host || host.dataset.scInit) return;
    host.dataset.scInit = '1';
    injectStyles();
    var traceUrl = buildTraceabilityURL(productId);
    var qrUrl = generateQR(traceUrl, 180);
    var now = new Date();
    var hashData = (productId || 'BLOOM') + now.toISOString();
    var realHash = await generateIntegrityHash(hashData);

    var html = '<div class="sc-wrap">';
    html += '<div class="sc-hd">';
    html += '<div>';
    html += '<div class="sc-title">\uD83D\uDD17 Supply Chain Traceability</div>';
    html += '<div class="sc-subtitle">6-stage hash-chain verified journey</div>';
    html += '</div>';
    html += '<div class="sc-qr-wrap">';
    html += '<img src="' + qrUrl + '" alt="QR code linking to supply chain trace" class="sc-qr" width="80" height="80" loading="lazy">';
    html += '<span class="sc-qr-label">Scan to verify</span>';
    html += '</div>';
    html += '</div>';
    html += '<div class="sc-timeline">';

    for (var i = 0; i < CHAIN_STAGES.length; i++) {
      var stage = CHAIN_STAGES[i];
      var stageTime = new Date(now.getTime() + (parseInt(stage.time) * 3600000));
      var timeStr = stageTime.toLocaleString('en-PH', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
      var isLast = i === CHAIN_STAGES.length - 1;
      var stageHash = await generateIntegrityHash(stage.id + stageTime.toISOString());
      html += '<div class="sc-stage' + (isLast ? ' sc-stage-last' : '') + '" data-stage="' + stage.id + '">';
      html += '<div class="sc-stage-line"><div class="sc-stage-dot">' + stage.icon + '</div></div>';
      html += '<div class="sc-stage-body">';
      html += '<div class="sc-stage-label">' + stage.label + '</div>';
      html += '<div class="sc-stage-meta">';
      html += '<span>\uD83D\uDCCD ' + stage.location + '</span>';
      html += '<span>\uD83C\uDF21\uFE0F ' + stage.temp + '</span>';
      html += '<span>\uD83D\uDD52 ' + timeStr + '</span>';
      html += '</div>';
      html += '<div class="sc-stage-desc">' + stage.desc + '</div>';
      html += '<div class="sc-stage-verifier">Verified by: ' + stage.verifier + '</div>';
      html += '<div class="sc-stage-hash">Stage hash: <code>' + stageHash + '</code></div>';
      html += '</div>';
      html += '</div>';
    }

    html += '</div>';
    html += '<div class="sc-footer">';
    html += '<div class="sc-hash">Chain hash: <code>' + realHash + '</code></div>';
    html += '<div class="sc-note">Integrity verification uses real Web Crypto API SHA-256 hashing. Hash-chain modeled on blockchain principles for this academic prototype.</div>';
    html += '</div>';
    html += '</div>';

    html += '<div class="sc-spacer"></div>';

    html += '<div class="ff-wrap">';
    html += '<div class="ff-hd">';
    html += '<div class="ff-title">\uD83C\uDF31 Grower Network</div>';
    html += '<div class="ff-subtitle">3 partner farms in Batangas province</div>';
    html += '</div>';
    html += '<div class="ff-grid">';

    for (var f = 0; f < FARMS.length; f++) {
      var farm = FARMS[f];
      var windyUrl = 'https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=\u00b0C&metricWind=km/h&zoom=12&overlay=temp&product=ecmwf&level=surface&lat=' + farm.lat + '&lon=' + farm.lon + '&detailLat=' + farm.lat + '&detailLon=' + farm.lon + '&marker=true&message=true';
      html += '<div class="ff-card">';
      html += '<div class="ff-cam">';
      html += '<iframe src="' + windyUrl + '" class="ff-windy-embed" frameborder="0" loading="lazy" title="Live weather conditions at ' + farm.name + '" allow="autoplay" allowfullscreen></iframe>';
      html += '<div class="ff-cam-overlay">';
      html += '<div class="ff-cam-badge">\u25CF LIVE CONDITIONS</div>';
      html += '</div>';
      html += '</div>';
      html += '<div class="ff-info">';
      html += '<div class="ff-farm-name">' + farm.name + '</div>';
      html += '<div class="ff-farm-meta">';
      html += '<span>\uD83C\uDF3E ' + farm.crop + '</span>';
      html += '<span>\u26F0\uFE0F ' + farm.altitude + '</span>';
      html += '<span>\uD83D\uDCCD ' + farm.region + '</span>';
      html += '</div>';
      html += '<div class="ff-farm-status"><div class="ff-status-dot"></div>' + farm.status + '</div>';
      html += '</div>';
      html += '</div>';
    }

    html += '</div>';
    html += '<div class="ff-footer">';
    html += '<div class="ff-note">Weather data powered by <a href="https://www.windy.com" target="_blank" rel="noopener">Windy.com</a> (ECMWF model). Farm coordinates reference Lipa City, Batangas, Philippines.</div>';
    html += '</div>';
    html += '</div>';

    host.innerHTML = html;
    animateTimeline(host);
  }

  function animateTimeline(host) {
    var stages = host.querySelectorAll('.sc-stage');
    stages.forEach(function (s, i) {
      s.style.opacity = '0';
      s.style.transform = 'translateX(-16px)';
      setTimeout(function () {
        s.style.transition = 'opacity .5s cubic-bezier(.23,1,.32,1), transform .5s cubic-bezier(.23,1,.32,1)';
        s.style.opacity = '1';
        s.style.transform = 'translateX(0)';
      }, 120 * i);
    });
    var cards = host.querySelectorAll('.ff-card');
    cards.forEach(function (c, i) {
      c.style.opacity = '0';
      c.style.transform = 'translateY(20px)';
      setTimeout(function () {
        c.style.transition = 'opacity .6s cubic-bezier(.23,1,.32,1), transform .6s cubic-bezier(.23,1,.32,1)';
        c.style.opacity = '1';
        c.style.transform = 'translateY(0)';
      }, 800 + (150 * i));
    });
  }

  function injectStyles() {
    if (document.getElementById('scStyles')) return;
    var s = document.createElement('style');
    s.id = 'scStyles';
    s.textContent =
      '.sc-wrap{border:1px solid rgba(255,255,255,.08);border-radius:20px;overflow:hidden;background:linear-gradient(135deg,rgba(255,255,255,.02),rgba(255,255,255,.005));backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}' +
      '.sc-hd{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:24px 24px 20px;border-bottom:1px solid rgba(255,255,255,.06)}' +
      '.sc-title{font-family:var(--fd);font-weight:700;font-size:1.15rem;margin-bottom:4px}' +
      '.sc-subtitle{font-size:.72rem;color:rgba(255,255,255,.35);letter-spacing:.03em}' +
      '.sc-qr-wrap{display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0}' +
      '.sc-qr{border-radius:10px;border:2px solid rgba(255,255,255,.08);background:#fff;padding:4px;transition:transform .3s ease}' +
      '.sc-qr:hover{transform:scale(1.08)}' +
      '.sc-qr-label{font-size:.58rem;color:rgba(255,255,255,.3);letter-spacing:.08em;text-transform:uppercase}' +
      '.sc-timeline{padding:24px;position:relative}' +
      '.sc-stage{display:flex;gap:16px;position:relative;padding-bottom:28px}' +
      '.sc-stage-last{padding-bottom:0}' +
      '.sc-stage-line{display:flex;flex-direction:column;align-items:center;flex-shrink:0;width:40px}' +
      '.sc-stage-dot{width:40px;height:40px;border-radius:50%;background:rgba(230,26,26,.08);border:2px solid rgba(230,26,26,.25);display:flex;align-items:center;justify-content:center;font-size:.95rem;position:relative;z-index:1;transition:border-color .3s,background .3s}' +
      '.sc-stage:hover .sc-stage-dot{border-color:rgba(230,26,26,.5);background:rgba(230,26,26,.15)}' +
      '.sc-stage:not(.sc-stage-last) .sc-stage-line::after{content:"";flex:1;width:2px;background:linear-gradient(180deg,rgba(230,26,26,.25),rgba(230,26,26,.06));margin-top:4px}' +
      '.sc-stage-body{flex:1;min-width:0}' +
      '.sc-stage-label{font-weight:700;font-size:.9rem;margin-bottom:5px}' +
      '.sc-stage-meta{display:flex;flex-wrap:wrap;gap:10px;font-size:.7rem;color:rgba(255,255,255,.4);margin-bottom:6px}' +
      '.sc-stage-desc{font-size:.78rem;color:rgba(255,255,255,.55);line-height:1.6;margin-bottom:4px}' +
      '.sc-stage-verifier{font-size:.62rem;color:rgba(255,255,255,.28);font-style:italic;margin-bottom:3px}' +
      '.sc-stage-hash{font-size:.58rem;color:rgba(255,255,255,.2)}' +
      '.sc-stage-hash code{background:rgba(255,255,255,.04);padding:1px 5px;border-radius:3px;font-family:monospace;color:rgba(0,212,170,.5);font-size:.56rem}' +
      '.sc-footer{padding:16px 24px;border-top:1px solid rgba(255,255,255,.06);display:flex;flex-direction:column;gap:6px}' +
      '.sc-hash{font-size:.7rem;color:rgba(255,255,255,.35)}' +
      '.sc-hash code{background:rgba(255,255,255,.05);padding:2px 8px;border-radius:5px;font-family:monospace;color:rgba(0,212,170,.7);font-size:.68rem}' +
      '.sc-note{font-size:.6rem;color:rgba(255,255,255,.22);line-height:1.6;font-style:italic}' +
      '.sc-spacer{height:32px}' +
      '.ff-wrap{border:1px solid rgba(255,255,255,.08);border-radius:20px;overflow:hidden;background:linear-gradient(135deg,rgba(255,255,255,.02),rgba(255,255,255,.005));backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}' +
      '.ff-hd{padding:24px 24px 20px;border-bottom:1px solid rgba(255,255,255,.06)}' +
      '.ff-title{font-family:var(--fd);font-weight:700;font-size:1.1rem;margin-bottom:4px}' +
      '.ff-subtitle{font-size:.72rem;color:rgba(255,255,255,.35);letter-spacing:.03em}' +
      '.ff-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:1px;background:rgba(255,255,255,.04)}' +
      '.ff-card{background:var(--bg,#0B0516);overflow:hidden;transition:background .3s}' +
      '.ff-card:hover{background:rgba(255,255,255,.03)}' +
      '.ff-cam{aspect-ratio:16/9;position:relative;overflow:hidden;background:#000}' +
      '.ff-windy-embed{width:100%;height:100%;border:0;pointer-events:auto}' +
      '.ff-cam-overlay{position:absolute;top:8px;left:8px;z-index:2;pointer-events:none}' +
      '.ff-cam-badge{font-size:.58rem;font-weight:700;padding:3px 10px;border-radius:6px;background:rgba(0,180,120,.15);color:rgba(0,220,150,.95);border:1px solid rgba(0,180,120,.3);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:inline-flex;align-items:center;gap:4px;letter-spacing:.04em}' +
      '.ff-info{padding:14px 18px}' +
      '.ff-farm-name{font-weight:700;font-size:.88rem;margin-bottom:6px}' +
      '.ff-farm-meta{display:flex;flex-wrap:wrap;gap:10px;font-size:.68rem;color:rgba(255,255,255,.4);margin-bottom:8px}' +
      '.ff-farm-status{display:flex;align-items:center;gap:6px;font-size:.72rem;color:rgba(0,212,170,.7)}' +
      '.ff-status-dot{width:7px;height:7px;border-radius:50%;background:rgba(0,212,170,.8);animation:sc-pulse 2s ease-in-out infinite}' +
      '.ff-footer{padding:14px 24px;border-top:1px solid rgba(255,255,255,.06)}' +
      '.ff-note{font-size:.58rem;color:rgba(255,255,255,.22);line-height:1.6;font-style:italic}' +
      '.ff-note a{color:rgba(0,212,170,.6);text-decoration:none}' +
      '.ff-note a:hover{text-decoration:underline}' +
      '@keyframes sc-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(.8)}}' +
      '[data-theme="light"] .sc-wrap,[data-theme="light"] .ff-wrap{background:rgba(0,0,0,.015);border-color:rgba(0,0,0,.08);backdrop-filter:none}' +
      '[data-theme="light"] .sc-hd,[data-theme="light"] .ff-hd{border-bottom-color:rgba(0,0,0,.06)}' +
      '[data-theme="light"] .sc-subtitle,[data-theme="light"] .ff-subtitle{color:rgba(26,18,32,.4)}' +
      '[data-theme="light"] .sc-stage-meta,[data-theme="light"] .ff-farm-meta{color:rgba(26,18,32,.45)}' +
      '[data-theme="light"] .sc-stage-desc{color:rgba(26,18,32,.6)}' +
      '[data-theme="light"] .sc-stage-verifier{color:rgba(26,18,32,.3)}' +
      '[data-theme="light"] .sc-stage-hash{color:rgba(26,18,32,.2)}' +
      '[data-theme="light"] .sc-stage-dot{background:rgba(230,26,26,.06);border-color:rgba(230,26,26,.2)}' +
      '[data-theme="light"] .sc-footer,[data-theme="light"] .ff-footer{border-top-color:rgba(0,0,0,.06)}' +
      '[data-theme="light"] .sc-hash{color:rgba(26,18,32,.35)}' +
      '[data-theme="light"] .sc-note,[data-theme="light"] .ff-note{color:rgba(26,18,32,.22)}' +
      '[data-theme="light"] .ff-card{background:var(--bg,#FEFCF9)}' +
      '[data-theme="light"] .ff-card:hover{background:rgba(0,0,0,.02)}' +
      '[data-theme="light"] .ff-grid{background:rgba(0,0,0,.06)}' +
      '[data-theme="light"] .ff-cam-badge{background:rgba(0,180,120,.1);color:rgba(0,140,100,.95);border-color:rgba(0,140,100,.25)}' +
      '@media(max-width:640px){.sc-hd{flex-direction:column}.ff-grid{grid-template-columns:1fr}.sc-stage-meta{flex-direction:column;gap:4px}}' +
      '@media(prefers-reduced-motion:reduce){.ff-status-dot{animation:none}.sc-stage,.ff-card{transition:none!important}}';
    document.head.appendChild(s);
  }
})();

;
(function () {
  'use strict';
  var GCASH_NUMBER = '09682976691';
  var GCASH_NAME = 'Bloombyus';
  var GCASH_QR_IMG = '/img/gcash-qr.png';

  window.BloomSupport = {
    renderSupportSection: renderSupportSection,
    renderFloatingButton: renderFloatingButton
  };

  function renderFloatingButton() {
    if (localStorage.getItem('hideBloomSupportFab') === '1') return;
    injectStyles();

    var container = document.createElement('div');
    container.className = 'gcash-fab-container';

    var fab = document.createElement('button');
    fab.className = 'gcash-fab';
    fab.setAttribute('aria-label', 'Support us via GCash');
    fab.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 7.9 3 4 6.6 4c2.2 0 3.7 1.2 4.4 2.4h2C13.7 5.2 15.2 4 17.4 4 21 4 23.1 7.9 21.6 11.7 19.5 16.4 12 21 12 21z"/></svg><span>Support&nbsp;Us</span>';
    fab.addEventListener('click', function () {
      var el =
        document.getElementById('supportUs') ||
        document.getElementById('supportUsContent') ||
        document.querySelector('.su-wrap');
      if (!el) {
        var target = '/#supportUs';
        if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
          window.location.hash = 'supportUs';
        } else {
          window.location.href = target;
        }
        return;
      }
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var spoiler = document.getElementById('suSpoiler');
      var card = document.getElementById('suGcashCard');
      var hideBtn = document.getElementById('suHideBtn');
      if (spoiler && card) {
        spoiler.classList.add('hidden');
        card.classList.remove('su-blurred');
        if (hideBtn) hideBtn.style.display = 'inline-flex';
      }
    });

    var closeBtn = document.createElement('button');
    closeBtn.className = 'gcash-fab-close';
    closeBtn.setAttribute('aria-label', 'Dismiss support button');
    closeBtn.innerHTML = '✕';
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      container.classList.remove('vis');
      setTimeout(function () {
        container.remove();
      }, 500);
      localStorage.setItem('hideBloomSupportFab', '1');
    });

    container.appendChild(fab);
    container.appendChild(closeBtn);
    document.body.appendChild(container);
    setTimeout(function () {
      container.classList.add('vis');
    }, 2000);
  }

  function renderSupportSection(containerId) {
    var host = document.getElementById(containerId);
    if (!host || host.dataset.suInit) return;
    host.dataset.suInit = '1';
    injectStyles();

    var html = '<div class="su-wrap">';
    html += '<div class="su-glow" aria-hidden="true"></div>';
    html += '<div class="su-inner">';
    html += '<div class="su-content">';
    html += '<span class="su-eyebrow">Community Support</span>';
    html += '<h3 class="su-title">Love what we\u2019re building?</h3>';
    html +=
      '<p class="su-desc">Bloom is an academic capstone project built with care by BSIT students at STI College Lipa. Your support helps us maintain servers, improve features, and keep the platform free for everyone.</p>';

    // Relative wrapper for card and optional spoiler overlay
    html += '<div class="su-gcash-card-container">';

    // Spoiler cover overlay (blurred backdrop)
    html += '<div class="su-spoiler-overlay" id="suSpoiler">';
    html += '<span class="su-spoiler-title">🌸 Optional Support Details</span>';
    html +=
      '<p class="su-spoiler-desc">This section contains donation options for the capstone project. Click below to toggle visibility.</p>';
    html += '<button class="su-spoiler-btn" id="suRevealBtn">Reveal Support Details</button>';
    html += '</div>';

    // GCash Details Card (blurred by default)
    html += '<div class="su-gcash-card su-blurred" id="suGcashCard">';
    html += '<div class="su-gcash-header">';
    html += '<div class="su-gcash-logo">';
    html +=
      '<svg viewBox="0 0 24 24" width="28" height="28" fill="none"><circle cx="12" cy="12" r="11" fill="#007DFE"/><text x="12" y="16" text-anchor="middle" fill="#fff" font-size="10" font-weight="900" font-family="Arial">G</text></svg>';
    html += '<div class="su-gcash-brand">';
    html += '<span class="su-gcash-label">GCash</span>';
    html += '<span class="su-gcash-sub">Send Money \u2022 Instant</span>';
    html += '</div>';
    html += '</div>';
    html += '<div class="su-gcash-verified">\u2713 Verified</div>';
    html += '</div>';
    html += '<div class="su-gcash-body">';
    html += '<div class="su-gcash-info">';
    html += '<div class="su-gcash-row">';
    html += '<span class="su-gcash-key">Mobile Number</span>';
    html += '<span class="su-gcash-val" id="gcashNum">' + GCASH_NUMBER + '</span>';
    html += '</div>';
    html += '<div class="su-gcash-row">';
    html += '<span class="su-gcash-key">Account Name</span>';
    html += '<span class="su-gcash-val">' + GCASH_NAME + '</span>';
    html += '</div>';
    html += '<div style="display:flex; gap:10px; align-items:center;">';
    html += '<button class="su-copy-btn" id="copyGcash" aria-label="Copy GCash number">';
    html +=
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
    html += '<span>Copy Number</span>';
    html += '</button>';
    // Optional toggle/hide details button
    html += '<button class="su-toggle-btn" id="suHideBtn" aria-label="Hide support details" style="display:none;">';
    html += '<span>Hide Details</span>';
    html += '</button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="su-gcash-qr">';
    html += '<div class="su-qr-frame">';
    html +=
      '<img src="' +
      GCASH_QR_IMG +
      '" alt="GCash QR Code for ' +
      GCASH_NUMBER +
      '" width="160" height="160" loading="lazy" onerror="this.onerror=null;this.src=\'https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=' +
      encodeURIComponent('GCash: ' + GCASH_NUMBER) +
      '\'">';
    html += '</div>';
    html += '<span class="su-qr-label">Scan to pay via GCash</span>';
    html += '</div>';
    html += '</div>';
    html += '</div>'; // End su-gcash-card

    html += '</div>'; // End su-gcash-card-container

    html +=
      '<div class="su-note">100% of contributions go toward hosting, development tools, and academic resources. GCash transfers are instant and free within the Philippines.</div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';

    host.innerHTML = html;

    var copyBtn = document.getElementById('copyGcash');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(GCASH_NUMBER).then(function () {
          copyBtn.querySelector('span').textContent = 'Copied!';
          copyBtn.classList.add('copied');
          setTimeout(function () {
            copyBtn.querySelector('span').textContent = 'Copy Number';
            copyBtn.classList.remove('copied');
          }, 2000);
        });
      });
    }

    // Toggle reveal/hide logic
    var spoiler = document.getElementById('suSpoiler');
    var revealBtn = document.getElementById('suRevealBtn');
    var card = document.getElementById('suGcashCard');
    var hideBtn = document.getElementById('suHideBtn');

    if (revealBtn && spoiler && card) {
      revealBtn.addEventListener('click', function () {
        spoiler.classList.add('hidden');
        card.classList.remove('su-blurred');
        if (hideBtn) hideBtn.style.display = 'inline-flex';
      });
    }

    if (hideBtn && spoiler && card) {
      hideBtn.addEventListener('click', function () {
        spoiler.classList.remove('hidden');
        card.classList.add('su-blurred');
        hideBtn.style.display = 'none';
      });
    }

    animateIn(host);
  }

  function animateIn(host) {
    var wrap = host.querySelector('.su-wrap');
    if (!wrap) return;
    wrap.style.opacity = '0';
    wrap.style.transform = 'translateY(24px)';
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            wrap.style.transition = 'opacity .7s cubic-bezier(.23,1,.32,1), transform .7s cubic-bezier(.23,1,.32,1)';
            wrap.style.opacity = '1';
            wrap.style.transform = 'translateY(0)';
            io.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(wrap);
  }

  function injectStyles() {
    if (document.getElementById('suStyles')) return;
    var s = document.createElement('style');
    s.id = 'suStyles';
    s.textContent =
      '.su-wrap{position:relative;border:1px solid rgba(255,255,255,.08);border-radius:24px;overflow:hidden;background:linear-gradient(135deg,rgba(0,125,254,.03),rgba(255,255,255,.01));backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px)}' +
      '.su-glow{position:absolute;top:-60px;right:-60px;width:300px;height:300px;background:radial-gradient(circle,rgba(0,125,254,.08),transparent 70%);pointer-events:none;filter:blur(50px);animation:suGlow 6s ease-in-out infinite alternate}' +
      '@keyframes suGlow{0%{opacity:.4;transform:scale(1)}100%{opacity:.7;transform:scale(1.2)}}' +
      '.su-inner{display:flex;flex-direction:column;gap:0;padding:clamp(28px,5vw,48px);position:relative;z-index:1}' +
      '.su-content{min-width:0}' +
      '.su-eyebrow{display:inline-block;font-family:var(--fc);font-style:italic;font-weight:900;font-size:.7rem;letter-spacing:.15em;text-transform:uppercase;color:rgba(0,125,254,.85);margin-bottom:12px;padding:4px 14px;background:rgba(0,125,254,.08);border:1px solid rgba(0,125,254,.2);border-radius:100px}' +
      '.su-title{font-family:var(--fd);font-size:clamp(1.4rem,3vw,2rem);font-weight:900;margin-bottom:12px;background:linear-gradient(135deg,#fff 30%,rgba(0,125,254,.9));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}' +
      '.su-desc{font-size:.9rem;color:rgba(255,255,255,.6);line-height:1.7;margin-bottom:28px;max-width:620px;text-wrap:pretty}' +
      '.su-gcash-card-container{position:relative;overflow:hidden;border-radius:20px;margin-bottom:20px;}' +
      '.su-gcash-card{background:linear-gradient(135deg,rgba(0,125,254,.06),rgba(255,255,255,.02));border:1px solid rgba(0,125,254,.15);border-radius:20px;overflow:hidden;margin-bottom:0!important;transition:filter .5s cubic-bezier(.23,1,.32,1)}' +
      '.su-gcash-card.su-blurred{filter:blur(16px);pointer-events:none;user-select:none;-webkit-user-select:none;}' +
      '.su-spoiler-overlay{position:absolute;inset:0;z-index:10;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px;background:rgba(8,3,16,.7);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);border-radius:20px;border:1px dashed rgba(0,125,254,.3);text-align:center;transition:opacity .4s ease,visibility .4s}' +
      '.su-spoiler-overlay.hidden{opacity:0;visibility:hidden;pointer-events:none}' +
      '.su-spoiler-title{font-family:var(--fd);font-size:1.15rem;font-weight:700;color:#fff;letter-spacing:-.01em}' +
      '.su-spoiler-desc{font-size:.8rem;color:rgba(255,255,255,.6);max-width:320px;line-height:1.5}' +
      '.su-spoiler-btn{padding:10px 20px;border-radius:12px;font-size:.82rem;font-weight:700;background:linear-gradient(135deg,#007DFE,#0055CC);color:#fff;border:none;cursor:pointer;box-shadow:0 6px 20px rgba(0,125,254,.3);transition:transform .2s,box-shadow .2s;font-family:inherit}' +
      '.su-spoiler-btn:hover{transform:translateY(-2px);box-shadow:0 10px 25px rgba(0,125,254,.45)}' +
      '.su-toggle-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:10px;font-size:.78rem;font-weight:700;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.6);cursor:pointer;transition:all .2s;font-family:inherit;margin-top:4px;align-self:flex-start}' +
      '.su-toggle-btn:hover{background:rgba(255,255,255,.1);color:#fff}' +
      '.su-gcash-header{display:flex;align-items:center;justify-content:space-between;padding:16px 24px;background:linear-gradient(135deg,rgba(0,125,254,.1),rgba(0,125,254,.04));border-bottom:1px solid rgba(0,125,254,.1)}' +
      '.su-gcash-logo{display:flex;align-items:center;gap:12px}' +
      '.su-gcash-brand{display:flex;flex-direction:column}' +
      '.su-gcash-label{font-family:var(--fd);font-weight:900;font-size:1.1rem;color:#007DFE;letter-spacing:.02em}' +
      '.su-gcash-sub{font-size:.68rem;color:rgba(255,255,255,.4);letter-spacing:.05em}' +
      '.su-gcash-verified{font-size:.68rem;font-weight:700;color:#22c55e;background:rgba(34,197,94,.1);padding:4px 10px;border-radius:100px;border:1px solid rgba(34,197,94,.2)}' +
      '.su-gcash-body{display:grid;grid-template-columns:1fr auto;gap:24px;padding:24px;align-items:center}' +
      '.su-gcash-info{display:flex;flex-direction:column;gap:14px}' +
      '.su-gcash-row{display:flex;flex-direction:column;gap:2px}' +
      '.su-gcash-key{font-size:.68rem;color:rgba(255,255,255,.35);letter-spacing:.08em;text-transform:uppercase;font-weight:600}' +
      '.su-gcash-val{font-family:var(--fd);font-size:1.2rem;font-weight:700;color:#fff;letter-spacing:.06em}' +
      '.su-copy-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:10px;font-size:.78rem;font-weight:700;background:linear-gradient(135deg,#007DFE,#0066D6);color:#fff;border:none;cursor:pointer;transition:transform .25s cubic-bezier(.23,1,.32,1),box-shadow .25s;font-family:inherit;margin-top:4px;align-self:flex-start}' +
      '.su-copy-btn:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(0,125,254,.35)}' +
      '.su-copy-btn.copied{background:linear-gradient(135deg,#22c55e,#16a34a)}' +
      '.su-gcash-qr{display:flex;flex-direction:column;align-items:center;gap:8px;flex-shrink:0}' +
      '.su-qr-frame{background:#fff;border-radius:14px;padding:10px;box-shadow:0 4px 20px rgba(0,0,0,.2)}' +
      '.su-qr-frame img{display:block;border-radius:6px;width:160px;height:160px;object-fit:contain}' +
      '.su-qr-label{font-size:.65rem;color:rgba(255,255,255,.3);text-align:center;letter-spacing:.04em}' +
      '.su-note{font-size:.68rem;color:rgba(255,255,255,.28);font-style:italic;line-height:1.6}' +
      '.gcash-fab-container{position:fixed;bottom:86px;left:24px;display:inline-flex;align-items:center;z-index:980;opacity:0;transform:translateY(16px);transition:opacity .5s cubic-bezier(.23,1,.32,1),transform .5s cubic-bezier(.23,1,.32,1);}' +
      '.gcash-fab-container.vis{opacity:1;transform:translateY(0)}' +
      '.gcash-fab{position:relative;display:inline-flex;align-items:center;gap:9px;padding:11px 20px 11px 18px;border-radius:100px 0 0 100px;background:linear-gradient(135deg,#3B9BFF 0%,#007DFE 45%,#0055CC 100%);color:#fff;font-size:.85rem;font-weight:700;letter-spacing:.01em;text-decoration:none;border:none;cursor:pointer;font-family:inherit;box-shadow:0 8px 24px rgba(0,125,254,.35),0 2px 6px rgba(0,0,0,.25),inset 0 1px 0 rgba(255,255,255,.25);transition:transform .25s cubic-bezier(.23,1,.32,1),box-shadow .25s,filter .25s}' +
      '.gcash-fab::after{content:"";position:absolute;inset:0;border-radius:inherit;background:linear-gradient(180deg,rgba(255,255,255,.18),transparent 50%);pointer-events:none}' +
      '.gcash-fab:hover{transform:translateY(-2px) scale(1.02);filter:brightness(1.08);box-shadow:0 14px 32px rgba(0,125,254,.45),0 4px 10px rgba(0,0,0,.3),inset 0 1px 0 rgba(255,255,255,.3)}' +
      '.gcash-fab-container.vis .gcash-fab{animation:suPulse 3.2s ease-in-out 1.6s 2}' +
      '@keyframes suPulse{0%,100%{box-shadow:0 8px 24px rgba(0,125,254,.35),0 2px 6px rgba(0,0,0,.25),inset 0 1px 0 rgba(255,255,255,.25)}50%{box-shadow:0 8px 24px rgba(0,125,254,.55),0 0 0 8px rgba(0,125,254,.12),0 2px 6px rgba(0,0,0,.25),inset 0 1px 0 rgba(255,255,255,.25)}}' +
      '.gcash-fab svg{flex-shrink:0}' +
      '.gcash-fab-close{display:inline-flex;align-items:center;justify-content:center;width:34px;height:42px;border-radius:0 100px 100px 0;background:linear-gradient(135deg,#0066D6 0%,#0044A6 100%);color:rgba(255,255,255,.75);font-size:.82rem;font-weight:600;border:none;cursor:pointer;box-shadow:0 8px 24px rgba(0,125,254,.35),0 2px 6px rgba(0,0,0,.25),inset 0 1px 0 rgba(255,255,255,.15),inset 1px 0 0 rgba(255,255,255,.08);transition:color .2s,background .25s,transform .25s}' +
      '.gcash-fab-close:hover{color:#fff;background:linear-gradient(135deg,#0055CC,#003a8c)}' +
      '[data-theme="light"] .su-wrap{background:linear-gradient(135deg,rgba(0,125,254,.04),rgba(0,0,0,.01));border-color:rgba(0,0,0,.08);backdrop-filter:none}' +
      '[data-theme="light"] .su-title{background:linear-gradient(135deg,var(--ink) 30%,rgba(0,100,200,.9));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}' +
      '[data-theme="light"] .su-desc{color:rgba(26,18,32,.6)}' +
      '[data-theme="light"] .su-note{color:rgba(26,18,32,.3)}' +
      '[data-theme="light"] .su-eyebrow{color:rgba(0,100,200,.9);background:rgba(0,125,254,.1);border-color:rgba(0,100,200,.25)}' +
      '[data-theme="light"] .su-gcash-val{color:var(--ink)}' +
      '[data-theme="light"] .su-gcash-key{color:rgba(26,18,32,.4)}' +
      '[data-theme="light"] .su-gcash-sub{color:rgba(26,18,32,.4)}' +
      '[data-theme="light"] .su-spoiler-overlay{background:rgba(255,255,255,.95);border-color:rgba(0,125,254,.2)}' +
      '[data-theme="light"] .su-spoiler-title{color:var(--ink)}' +
      '[data-theme="light"] .su-spoiler-desc{color:rgba(26,18,32,.6)}' +
      '@media(max-width:640px){.su-gcash-body{grid-template-columns:1fr;text-align:center}.su-gcash-qr{margin-top:8px}.su-gcash-info{align-items:center}.su-copy-btn{align-self:center}.gcash-fab-container{left:auto;right:16px;bottom:96px}.gcash-fab span{display:none}.gcash-fab{padding:0;width:46px;height:46px;justify-content:center;border-radius:100px 0 0 100px}.gcash-fab svg{width:22px;height:22px}.gcash-fab-close{width:30px;height:46px;border-radius:0 100px 100px 0;font-size:.75rem}}' +
      '@media(prefers-reduced-motion:reduce){.su-glow,.gcash-fab-container{animation:none!important}}';
    document.head.appendChild(s);
  }
})();

;
